// This file is auto-generated by @hey-api/openapi-ts
import { accountNumberGetAccountNumber, accountNumberUpdateAccountNumber, transferAchPositivePayRulesCreateAchPositivePayRule, transferAchPositivePayRulesDeleteAchPositivePayRule, transferAchPositivePayRulesGetAchPositivePayRule, bankAccountListBankAccounts, bankAccountCreateBankAccount, bankAccountDeleteBankAccount, bankAccountGetBankAccount, bankAccountUpdateBankAccount, accountNumberListAccountNumbers, accountNumberCreateAccountNumber, transferAchPositivePayRulesListAchPositivePayRulesByBankAccount, bankAccountListBankAccountActivities, bankAccountGetBankAccountHistory, bankAccountAddBankAccountOwner, counterpartyListCounterparties, counterpartyCreateCounterparty, counterpartyDeleteCounterparty, counterpartyGetCounterparty, transferCryptoListCounterparties, transferCryptoCreateCounterparty, transferCryptoGetCounterparty, cryptoPaymentAddressListCryptoPaymentAddress, cryptoPaymentAddressCreateCryptoPaymentAddress, cryptoPaymentAddressDeleteCryptoPaymentAddress, cryptoPaymentAddressGetCryptoPaymentAddress, dashboardUserAcceptLegalAgreement, adminapprovalListAdminApprovals, adminapprovalReviewAdminApproval, adminapprovalCreateAdminApprovalReviewBatch, apikeyCreateApiKey, approvalsListApprovals, approvalsGetApproval, approvalsCreateTransferReviewBatch, approvalsGetTransferReviewBatch, externalappsListApps, externalappsGetApp, dashboardUserUpdateDashboardUser, roleAssignRole, dashboardUserListInvites, dashboardUserListPlatformRoles, dashboardUserGetDashboardUserPlatformModeSettings, dashboardUserUpdateDashboardUserPlatformModeSettings, dashboardUserGetDashboardUserSettings, dashboardUserUpdateDashboardUserSettings, helpSubmit, inviteListInvites, inviteCreatePlatformInvite, inviteDeleteInvite, inviteResendInviteEmail, loginConfirmLoginEmailChallenge, onboardingGetDependencyGraphValues, onboardingUpdateDependencyGraphValues, onboardingUploadFile, platformGetPlatform, platformUpdatePlatform, apikeyListApiKeys, apikeyDeleteApiKey, apikeyGetApiKey, apikeyUpdateApiKey, apikeyRevealApiKey, documentsListPlatformDocuments, documentsUploadPlatformDocument, documentsGetPlatformDocument, platformGetPlatformMetadata, platformUpdatePlatformMetadata, identityEntityGetRootEntity, identityEntityCreateBusinessRootEntity, identityEntityCreatePersonRootEntity, platformGetPlatformModeConfig, platformUpdatePlatformModeConfig, transferTemplateListPlatformTransferTemplates, transferTemplateCreatePlatformTransferTemplate, transferTemplateDeletePlatformTransferTemplate, transferTemplateGetPlatformTransferTemplate, transferTemplateUpdatePlatformTransferTemplate, roleListRoles, roleCreateCustomRole, roleDeleteCustomRole, roleGetCustomRole, roleUpdateCustomRole, ssoLoginCallback, ssoListConnections, ssoCreateConnection, ssoDeleteConnection, ssoGetConnection, ssoUpdateConnection, ssoCreateDomain, ssoDeleteDomain, ssoVerifyDomain, ssoInitiateLogin, ssoInitiateLoginForm, webauthnBeginLogin, webauthnFinishLogin, webauthnBeginRegistration, webauthnFinishRegistration, documentsListDocuments, documentsUploadRegularDocument, documentsGetDocument, identityEntityGetEntities, identityEntityDeleteEntity, identityEntityGetEntity, identityEntityGetAdditionalRequirements, identityEntitySubmitAdditionalRequirements, identityEntityGetAssociatedPersons, identityEntityLinkAssociatedPerson, identityEntityUpdateAssociatedPersons, identityEntityGetEntityCompliance, identityEntityGetEntityEvidence, identityEntityCreateEntityEvidence, identityEntityGetEntityNarratives, identityEntityCreateEntityNarrative, identityEntityDeleteEntityNarrative, identityEntityCreateBusinessEntity, identityEntityUpdateBusinessEntity, identityEntityCreatePersonEntity, identityEntityUpdatePersonEntity, eventListEvents, eventGetEvent, eventListWebhookEvents, financialInstitutionGetIban, financialInstitutionListFinancialInstitutions, financialInstitutionGetFinancialInstitution, interestsListConfigs, interestsCreateConfig, interestsGetConfig, interestsUpdateConfig, interestsListPayouts, interestsGetPayout, interestsListPivotRates, interestsCreatePivotRate, interestsDeletePivotRate, interestsGetPivotRate, interestsUpdatePivotRate, cardsListCardAccounts, cardsCreateCardAccount, cardsGetCardAccount, cardsCloseCardAccount, cardsReinstateCardAccount, cardsSuspendCardAccount, cardsCreateCardAuthorizationPolicy, cardsListCardAuthorizationPolicyVersions, cardsCreateCardAuthorizationPolicyVersion, cardsDeleteCardAuthorizationPolicyVersion, cardsGetCardAuthorizationPolicyVersion, cardsUpdateCardAuthorizationPolicyVersion, cardsCheckCardDisputeEligibility, cardsListCardDisputes, cardsCreateCardDispute, cardsGetDispute, cardsCloseCardDispute, cardsAddCardDisputeEvidence, cardsRemoveCardDisputeProvisionalCredit, cardsIssueCardDisputeProvisionalCredit, cardsRespondCardDispute, cardsSubmitCardDispute, cardsUploadCardDisputeDocument, cardsGetCardDisputeDocument, cardsListCardPrograms, cardsGetCardProgram, cardsUpdateCardProgram, cardsListCardTemplates, cardsListCardTokens, cardsGetCardToken, cardsActivateCardToken, cardsDeactivateCardToken, cardsPauseCardToken, cardsListCardTransactions, cardsGetCardTransaction, cardsListCards, cardsCreateCard, cardsGetCard, cardsUpdateCard, cardsActivateCard, cardsAddCardToWallet, cardsDeactivateCard, cardsPauseCard, cardsDeleteCardPin, cardsUpdateCardPin, cardsUnblockCardPin, cardsRenewCard, cardsReplaceCard, cardsRevealCardDetails, cardsCreateCardRevealToken, lendingLoanListLoans, lendingLoanCreateLoan, lendingLoanGetLoan, lendingLoanUpdateLoan, lendingPaymentsApplyLoanCollateral, lendingLoanGetLoanHistory, lendingSaleCreateSale, lendingDisbursementsListDisbursements, lendingDisbursementsCreateDisbursement, lendingDisbursementsGetDisbursement, lendingDisbursementsUpdateDisbursementHold, lendingDisbursementsCancelDisbursementHold, lendingDisbursementsClearDisbursementHold, lendingPaymentsListLoanPayments, lendingPaymentsCreateLoanPayment, lendingPaymentsGetLoanPayment, lendingPaymentsReturnLoanPayment, lendingLoanListLoanPrograms, lendingLoanGetLoanProgram, lendingLoanUpdateLoanProgram, lendingSaleListSales, lendingSaleGetSale, lendingSaleGetDailyLoansAvailableForSale, lendingSaleGetDailySoldLoans, miscGetMarketRates, reportingListSettlementReports, reportingScheduleSettlementReport, reportingGetSettlementReport, bankAccountExportBankAccountActivities, transferChecksDepositIssuedCheck, interestsPayoutInterest, cardsCreateCardProgram, cardsCloseCardProgram, cardsSimulateCapture, cardsSimulateIncrementalAuthorization, cardsSimulateRefund, cardsSimulateReversal, cardsSimulateAddCardToWallet, cardsSimulateCardAuthorization, cardsSimulateCardFinancial, cardsSimulateRevealCardDetails, cardsSimulateThreeDsChallenge, cardsSimulateApproveProvisioning, cardsSimulateDeactivate, cardsSimulateDeviceBinding, cardsSimulateResume, cardsSimulateStepUpComplete, cardsSimulateStepUpMethods, cardsSimulateSendPasscode, cardsSimulateSuspend, cardsSimulateCheckEligibility, cardsSimulateCompleteThreeDsChallenge, transferAchReceiveAchCreditTransfer, transferAchReceiveAchDebitTransfer, transferSwiftReceiveCorrespondentSwift, transferWireReceiveInternationalWire, transferLocalReceiveLocalTransfer, transferSwiftReceiveSwiftAccountReportRequest, transferWireReceiveWireTransfer, transferWireReceiveWireDrawdownRequest, transferWireReceiveWireReturnRequest, taxFormsCreateTaxForm, transferAchSettleAchTransfer, transferChecksSettleCheckTransfer, transferRealtimeReceiveCredit, transferRealtimeReceiveRfp, transferWireSettleWireTransfer, taxFormListTaxForms, taxFormGetTaxForm, taxFormCancelMailing, taxFormScheduleMailing, transferSearchTransfers, transferAchListTransfers, transferAchCreateTransfer, transferAchGetTransfer, transferAchCancelTransfer, transferAchClearTransfer, transferAchGetReturn, transferAchCreateReturn, transferAchReverseTransfer, transferAchBatchListBatches, transferAchBatchCreateBatch, transferAchBatchGetBatch, transferAchBatchCancelBatch, transferAchBatchConfirmBatch, transferAchBatchUploadFile, transferAchBatchListBatchRecords, transferAchBatchGetBatchRecord, transferAchListReturns, transferAdminGetAdminTransfer, transferBatchListTransferBatches, transferBatchCreateTransferBatch, transferBatchDeleteTransferBatch, transferBatchGetTransferBatch, transferBatchUpdateTransferBatch, transferBookListBookTransfers, transferBookCreateBookTransfer, transferBookGetBookTransfer, transferBookUpdateBookTransfer, transferBookCancelBookTransfer, transferBookClearBookTransfer, transferCheckListCheckTransfers, transferCheckGetCheckTransfer, transferCheckClearHeldCheck, transferCheckCancelHeldCheck, transferCheckGetPreviewPdf, transferCheckCreateCheckReturn, transferCheckGetCheckReturns, transferCheckReviewTransfer, transferCheckStopPayment, transferCheckDepositCheck, transferCheckDepositbatchListBatches, transferCheckDepositbatchCreateBatch, transferCheckDepositbatchDeleteBatch, transferCheckDepositbatchGetBatch, transferCheckDepositbatchUpdateBatch, transferCheckProcessCheckBackImage, transferCheckProcessCheckFrontImage, transferCheckIssueCheck, transferCheckLockboxListLockboxes, transferCheckLockboxCreateLockbox, transferCheckLockboxDeleteLockbox, transferCheckLockboxGetLockbox, transferCheckListCheckReturns, transferCryptoListTransfers, transferCryptoCreateTransfer, transferCryptoGetTransfer, transferCryptoClearHeldTransfer, transferCryptoCancelHeldTransfer, transferFxtradeListFxTrades, transferFxtradeCreateFxTrade, transferFxtradeGetFxTrade, transferFxtradeBookFxTrade, transferFxtradeCancelFxTrade, transferFxtradeGetFxTradeConfig, transferFxtradeUpdateFxTradeConfig, transferSwiftListTransfers, transferSwiftCreateTransfer, transferSwiftGetTransfer, transferSwiftCreateAmendment, transferSwiftCancelTransfer, transferSwiftClearHeldTransfer, transferSwiftCancelHeldTransfer, transferSwiftReturnTransfer, transferSwiftTrackTransfer, transferSwiftCreateFinancialInstitutionTransfer, transferSwiftQueryFxQuote, transferSwiftQueryFxRateSheet, transferSwiftGetFxQuote, transferSwiftBookFxQuote, transferSwiftCancelFxQuote, transferLocalListTransfers, transferLocalCreateTransfer, transferLocalGetTransfer, transferLocalCancelTransfer, transferRealtimeListTransfers, transferRealtimeCreateTransfer, transferRealtimeGetTransfer, transferRealtimeCancelTransfer, transferRealtimeClearTransfer, transferRealtimeReturnTransfer, transferRealtimeCreateReturnRequest, transferRealtimeListRfp, transferRealtimeCreateRfp, transferRealtimeGetRfp, transferRealtimeAcceptRfp, transferRealtimeRejectRfp, transferRealtimeListReturnRequests, transferRealtimeGetReturnRequest, transferRealtimeAcceptReturnRequest, transferRealtimeRejectReturnRequest, transferWireListWireTransfers, transferWireCreateWireTransfer, transferWireGetWireTransfer, transferWireCancelWireTransfer, transferWireClearWireTransfer, transferWireCreateWireReturnRequest, transferWireReverseWireTransfer, transferWireListWireDrawdownRequests, transferWireCreateWireDrawdown, transferWireGetWireDrawdownRequest, transferWireApproveWireDrawdownRequest, transferWireListWireReturnRequests, transferWireGetWireReturnRequest, transferWireApproveWireReturnRequest, transferWireRejectWireReturnRequest, webhookListEndpointWebhookDeliveries, webhookListEventWebhookDeliveries, webhookListWebhookEndpoints, webhookCreateWebhookEndpoint, webhookDeleteWebhookEndpoint, webhookGetWebhookEndpoint, webhookUpdateWebhookEndpoint, webhookVerifyWebhookEndpoint, webhookListEndpointWebhookDeliveries2, webhookListEventWebhookDeliveries2, webhookListWebhookEndpoints2, webhookCreateWebhookEndpoint2, webhookDeleteWebhookEndpoint2, webhookGetWebhookEndpoint2, webhookUpdateWebhookEndpoint2, webhookVerifyWebhookEndpoint2, } from '../sdk.gen';
import { queryOptions } from '@tanstack/react-query';
import { client as _heyApiClient } from '../client.gen';
const createQueryKey = (id, options, infinite) => {
    const params = {
        _id: id,
        baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl,
    };
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};
export const accountNumberGetAccountNumberQueryKey = (options) => createQueryKey('accountNumberGetAccountNumber', options);
/**
 * Get an account number
 * Gets a specific account number by its ID.
 */
export const accountNumberGetAccountNumberOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountNumberGetAccountNumber({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: accountNumberGetAccountNumberQueryKey(options),
    });
};
/**
 * Update an account number
 * Updates an account number by its ID.
 */
export const accountNumberUpdateAccountNumberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await accountNumberUpdateAccountNumber({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchPositivePayRulesCreateAchPositivePayRuleQueryKey = (options) => createQueryKey('transferAchPositivePayRulesCreateAchPositivePayRule', options);
/**
 * Create an ACH positive pay rule
 * Creates an ACH positive pay rule on a bank account.
 */
export const transferAchPositivePayRulesCreateAchPositivePayRuleOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchPositivePayRulesCreateAchPositivePayRule({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchPositivePayRulesCreateAchPositivePayRuleQueryKey(options),
    });
};
/**
 * Create an ACH positive pay rule
 * Creates an ACH positive pay rule on a bank account.
 */
export const transferAchPositivePayRulesCreateAchPositivePayRuleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchPositivePayRulesCreateAchPositivePayRule({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete an ACH positive pay rule
 * Delete an ACH positive pay rule by its ID.
 */
export const transferAchPositivePayRulesDeleteAchPositivePayRuleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchPositivePayRulesDeleteAchPositivePayRule({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchPositivePayRulesGetAchPositivePayRuleQueryKey = (options) => createQueryKey('transferAchPositivePayRulesGetAchPositivePayRule', options);
/**
 * Get an ACH positive pay rule
 * Retrieve a single ACH positive pay rule by its ID.
 */
export const transferAchPositivePayRulesGetAchPositivePayRuleOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchPositivePayRulesGetAchPositivePayRule({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchPositivePayRulesGetAchPositivePayRuleQueryKey(options),
    });
};
export const bankAccountListBankAccountsQueryKey = (options) => createQueryKey('bankAccountListBankAccounts', options);
/**
 * List all bank accounts
 * List all bank accounts under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const bankAccountListBankAccountsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bankAccountListBankAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: bankAccountListBankAccountsQueryKey(options),
    });
};
export const bankAccountCreateBankAccountQueryKey = (options) => createQueryKey('bankAccountCreateBankAccount', options);
/**
 * Create a new bank account
 * Creates a new bank account under an entity.
 */
export const bankAccountCreateBankAccountOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bankAccountCreateBankAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: bankAccountCreateBankAccountQueryKey(options),
    });
};
/**
 * Create a new bank account
 * Creates a new bank account under an entity.
 */
export const bankAccountCreateBankAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await bankAccountCreateBankAccount({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a bank account
 * This deletes a bank account.
 */
export const bankAccountDeleteBankAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await bankAccountDeleteBankAccount({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const bankAccountGetBankAccountQueryKey = (options) => createQueryKey('bankAccountGetBankAccount', options);
/**
 * Get a bank account by ID
 * Get a bank account by its ID.
 */
export const bankAccountGetBankAccountOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bankAccountGetBankAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: bankAccountGetBankAccountQueryKey(options),
    });
};
/**
 * Update a bank account
 * Updates a bank account by its ID.
 */
export const bankAccountUpdateBankAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await bankAccountUpdateBankAccount({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const accountNumberListAccountNumbersQueryKey = (options) => createQueryKey('accountNumberListAccountNumbers', options);
/**
 * List all account numbers from a bank account
 * Lists all the account numbers that point to a specific bank account.
 */
export const accountNumberListAccountNumbersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountNumberListAccountNumbers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: accountNumberListAccountNumbersQueryKey(options),
    });
};
export const accountNumberCreateAccountNumberQueryKey = (options) => createQueryKey('accountNumberCreateAccountNumber', options);
/**
 * Create a new account number
 * Creates a new account number that points to the associated bank account.
 */
export const accountNumberCreateAccountNumberOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await accountNumberCreateAccountNumber({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: accountNumberCreateAccountNumberQueryKey(options),
    });
};
/**
 * Create a new account number
 * Creates a new account number that points to the associated bank account.
 */
export const accountNumberCreateAccountNumberMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await accountNumberCreateAccountNumber({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchPositivePayRulesListAchPositivePayRulesByBankAccountQueryKey = (options) => createQueryKey('transferAchPositivePayRulesListAchPositivePayRulesByBankAccount', options);
/**
 * List ACH positive pay rules
 * Gets all ACH positive pay rules on a bank account.
 */
export const transferAchPositivePayRulesListAchPositivePayRulesByBankAccountOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchPositivePayRulesListAchPositivePayRulesByBankAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchPositivePayRulesListAchPositivePayRulesByBankAccountQueryKey(options),
    });
};
export const bankAccountListBankAccountActivitiesQueryKey = (options) => createQueryKey('bankAccountListBankAccountActivities', options);
/**
 * List bank account activities
 * List the activity line items on a bank account, newest first. Each line item is one posting to the account, as it would appear on a bank statement, with the account's running balance after it posted. Transfers in a batch that is rolled up on statements, such as a check deposit batch, are combined into one line item per batch per day (UTC). Amounts are in the smallest unit of the account's currency, which the response returns as `currency_code`. Filter by posting time with the `effective_at_*` parameters.
 */
export const bankAccountListBankAccountActivitiesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bankAccountListBankAccountActivities({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: bankAccountListBankAccountActivitiesQueryKey(options),
    });
};
export const bankAccountGetBankAccountHistoryQueryKey = (options) => createQueryKey('bankAccountGetBankAccountHistory', options);
/**
 * Get bank account summary history
 * Get the summary history of a bank account. This endpoint returns a list of summaries, one summary per day, for a single bank account. Only summaries for the latest 366 days are available. You must set your platform reporting time zone in Platform Settings on Dashboard to use this endpoint ([read more]({{guides.reporting}})).
 */
export const bankAccountGetBankAccountHistoryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bankAccountGetBankAccountHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: bankAccountGetBankAccountHistoryQueryKey(options),
    });
};
export const bankAccountAddBankAccountOwnerQueryKey = (options) => createQueryKey('bankAccountAddBankAccountOwner', options);
/**
 * Add a bank account owner
 * Adds an additional owner to an existing bank account. This enables joint ownership where multiple entities can have ownership rights. The entity must be verified before being added as an owner and must belong to the same platform as the bank account.
 */
export const bankAccountAddBankAccountOwnerOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bankAccountAddBankAccountOwner({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: bankAccountAddBankAccountOwnerQueryKey(options),
    });
};
/**
 * Add a bank account owner
 * Adds an additional owner to an existing bank account. This enables joint ownership where multiple entities can have ownership rights. The entity must be verified before being added as an owner and must belong to the same platform as the bank account.
 */
export const bankAccountAddBankAccountOwnerMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await bankAccountAddBankAccountOwner({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const counterpartyListCounterpartiesQueryKey = (options) => createQueryKey('counterpartyListCounterparties', options);
/**
 * List all counterparties
 * Retrieve all counterparties under your developer account. Filtered results can be retrieved with extra parameters in the query (`account_number`, `routing_number`, etc.).
 */
export const counterpartyListCounterpartiesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await counterpartyListCounterparties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: counterpartyListCounterpartiesQueryKey(options),
    });
};
export const counterpartyCreateCounterpartyQueryKey = (options) => createQueryKey('counterpartyCreateCounterparty', options);
/**
 * Create a counterparty
 * A counterparty is the legal entity on the other side of the transaction. Depending on the type of transaction, we may need to know more or less about them. A domestic ACH only requires a counterparty's account and routing number. If you include a counterparty name, Column will by default populate `receiver_name` on the ACH transfer request. Domestic and international wires require full name and address. Certain countries may require additional fields. Learn more about country-specific details here.
 */
export const counterpartyCreateCounterpartyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await counterpartyCreateCounterparty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: counterpartyCreateCounterpartyQueryKey(options),
    });
};
/**
 * Create a counterparty
 * A counterparty is the legal entity on the other side of the transaction. Depending on the type of transaction, we may need to know more or less about them. A domestic ACH only requires a counterparty's account and routing number. If you include a counterparty name, Column will by default populate `receiver_name` on the ACH transfer request. Domestic and international wires require full name and address. Certain countries may require additional fields. Learn more about country-specific details here.
 */
export const counterpartyCreateCounterpartyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await counterpartyCreateCounterparty({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a counterparty
 * Delete a counterparty.
 */
export const counterpartyDeleteCounterpartyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await counterpartyDeleteCounterparty({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const counterpartyGetCounterpartyQueryKey = (options) => createQueryKey('counterpartyGetCounterparty', options);
/**
 * Get a counterparty by ID
 * Retrieve a single counterparty by its ID.
 */
export const counterpartyGetCounterpartyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await counterpartyGetCounterparty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: counterpartyGetCounterpartyQueryKey(options),
    });
};
export const transferCryptoListCounterpartiesQueryKey = (options) => createQueryKey('transferCryptoListCounterparties', options);
/**
 * List all crypto counterparties
 * List all crypto counterparties with optional filtering and pagination.
 */
export const transferCryptoListCounterpartiesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCryptoListCounterparties({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCryptoListCounterpartiesQueryKey(options),
    });
};
export const transferCryptoCreateCounterpartyQueryKey = (options) => createQueryKey('transferCryptoCreateCounterparty', options);
/**
 * Create a crypto counterparty
 * Create a new crypto counterparty that can be used as a recipient for outgoing crypto transfers.
 */
export const transferCryptoCreateCounterpartyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCryptoCreateCounterparty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCryptoCreateCounterpartyQueryKey(options),
    });
};
/**
 * Create a crypto counterparty
 * Create a new crypto counterparty that can be used as a recipient for outgoing crypto transfers.
 */
export const transferCryptoCreateCounterpartyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCryptoCreateCounterparty({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCryptoGetCounterpartyQueryKey = (options) => createQueryKey('transferCryptoGetCounterparty', options);
/**
 * Get a crypto counterparty
 * Retrieve a specific crypto counterparty by ID.
 */
export const transferCryptoGetCounterpartyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCryptoGetCounterparty({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCryptoGetCounterpartyQueryKey(options),
    });
};
export const cryptoPaymentAddressListCryptoPaymentAddressQueryKey = (options) => createQueryKey('cryptoPaymentAddressListCryptoPaymentAddress', options);
/**
 * List all crypto payment addresses
 * Retrieve all crypto payment addresses under your developer account. Filtered results can be retrieved with extra parameters in the query.
 */
export const cryptoPaymentAddressListCryptoPaymentAddressOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cryptoPaymentAddressListCryptoPaymentAddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cryptoPaymentAddressListCryptoPaymentAddressQueryKey(options),
    });
};
export const cryptoPaymentAddressCreateCryptoPaymentAddressQueryKey = (options) => createQueryKey('cryptoPaymentAddressCreateCryptoPaymentAddress', options);
/**
 * Create a crypto payment address
 * Create a new crypto payment address that customers can use to pay stablecoins into and out of. Column will automatically detect incoming payments and settle the equivalent fiat amount into the associated bank account. Outgoing stablecoin transfers can also be initiated from the address.
 */
export const cryptoPaymentAddressCreateCryptoPaymentAddressOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cryptoPaymentAddressCreateCryptoPaymentAddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cryptoPaymentAddressCreateCryptoPaymentAddressQueryKey(options),
    });
};
/**
 * Create a crypto payment address
 * Create a new crypto payment address that customers can use to pay stablecoins into and out of. Column will automatically detect incoming payments and settle the equivalent fiat amount into the associated bank account. Outgoing stablecoin transfers can also be initiated from the address.
 */
export const cryptoPaymentAddressCreateCryptoPaymentAddressMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cryptoPaymentAddressCreateCryptoPaymentAddress({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a crypto payment address
 * Close a crypto payment address by its ID. This transitions the address's `status` to `closed`. The address and its transaction history remain visible in `GET` and `LIST` responses, and once closed an address cannot be reopened. On-chain transactions sent to a closed address will arrive and will be detected and recorded against the address, but they will not be converted into fiat. Funds are held and routed into the existing return-funds flow so they can be returned to the sender.
 */
export const cryptoPaymentAddressDeleteCryptoPaymentAddressMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cryptoPaymentAddressDeleteCryptoPaymentAddress({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cryptoPaymentAddressGetCryptoPaymentAddressQueryKey = (options) => createQueryKey('cryptoPaymentAddressGetCryptoPaymentAddress', options);
/**
 * Get crypto payment address
 * Retrieve a single crypto payment address by its ID.
 */
export const cryptoPaymentAddressGetCryptoPaymentAddressOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cryptoPaymentAddressGetCryptoPaymentAddress({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cryptoPaymentAddressGetCryptoPaymentAddressQueryKey(options),
    });
};
export const dashboardUserAcceptLegalAgreementQueryKey = (options) => createQueryKey('dashboardUserAcceptLegalAgreement', options);
/**
 * Accept legal agreement
 * Accept the current legal agreement.
 */
export const dashboardUserAcceptLegalAgreementOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dashboardUserAcceptLegalAgreement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dashboardUserAcceptLegalAgreementQueryKey(options),
    });
};
/**
 * Accept legal agreement
 * Accept the current legal agreement.
 */
export const dashboardUserAcceptLegalAgreementMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await dashboardUserAcceptLegalAgreement({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const adminapprovalListAdminApprovalsQueryKey = (options) => createQueryKey('adminapprovalListAdminApprovals', options);
/**
 * List admin approvals
 * List user and role changes that require a second user's approval.
 */
export const adminapprovalListAdminApprovalsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminapprovalListAdminApprovals({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: adminapprovalListAdminApprovalsQueryKey(options),
    });
};
export const adminapprovalReviewAdminApprovalQueryKey = (options) => createQueryKey('adminapprovalReviewAdminApproval', options);
/**
 * Review an admin approval
 * Approve or reject a pending admin approval.
 */
export const adminapprovalReviewAdminApprovalOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminapprovalReviewAdminApproval({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: adminapprovalReviewAdminApprovalQueryKey(options),
    });
};
/**
 * Review an admin approval
 * Approve or reject a pending admin approval.
 */
export const adminapprovalReviewAdminApprovalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await adminapprovalReviewAdminApproval({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const adminapprovalCreateAdminApprovalReviewBatchQueryKey = (options) => createQueryKey('adminapprovalCreateAdminApprovalReviewBatch', options);
/**
 * Review admin approvals in a batch
 * Approve or reject up to 100 pending admin approvals with a single decision, or preview them with a dry run.
 */
export const adminapprovalCreateAdminApprovalReviewBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await adminapprovalCreateAdminApprovalReviewBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: adminapprovalCreateAdminApprovalReviewBatchQueryKey(options),
    });
};
/**
 * Review admin approvals in a batch
 * Approve or reject up to 100 pending admin approvals with a single decision, or preview them with a dry run.
 */
export const adminapprovalCreateAdminApprovalReviewBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await adminapprovalCreateAdminApprovalReviewBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const apikeyCreateApiKeyQueryKey = (options) => createQueryKey('apikeyCreateApiKey', options);
/**
 * Create API key
 * Create a new API key for the current platform.
 */
export const apikeyCreateApiKeyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apikeyCreateApiKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: apikeyCreateApiKeyQueryKey(options),
    });
};
/**
 * Create API key
 * Create a new API key for the current platform.
 */
export const apikeyCreateApiKeyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await apikeyCreateApiKey({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const approvalsListApprovalsQueryKey = (options) => createQueryKey('approvalsListApprovals', options);
/**
 * List pending approvals
 * List pending actions that require approval from the caller.
 */
export const approvalsListApprovalsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await approvalsListApprovals({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: approvalsListApprovalsQueryKey(options),
    });
};
export const approvalsGetApprovalQueryKey = (options) => createQueryKey('approvalsGetApproval', options);
/**
 * Get the approval state of a reviewable object
 * Retrieve the approval state of a single reviewable object.
 */
export const approvalsGetApprovalOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await approvalsGetApproval({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: approvalsGetApprovalQueryKey(options),
    });
};
export const approvalsCreateTransferReviewBatchQueryKey = (options) => createQueryKey('approvalsCreateTransferReviewBatch', options);
/**
 * Review held transfers in a batch
 * Approve or reject held transfers with a single decision, or preview the eligible transfers with a dry run.
 */
export const approvalsCreateTransferReviewBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await approvalsCreateTransferReviewBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: approvalsCreateTransferReviewBatchQueryKey(options),
    });
};
/**
 * Review held transfers in a batch
 * Approve or reject held transfers with a single decision, or preview the eligible transfers with a dry run.
 */
export const approvalsCreateTransferReviewBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await approvalsCreateTransferReviewBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const approvalsGetTransferReviewBatchQueryKey = (options) => createQueryKey('approvalsGetTransferReviewBatch', options);
/**
 * Get a transfer review batch
 * Retrieve a transfer review batch and the outcome for each transfer.
 */
export const approvalsGetTransferReviewBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await approvalsGetTransferReviewBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: approvalsGetTransferReviewBatchQueryKey(options),
    });
};
export const externalappsListAppsQueryKey = (options) => createQueryKey('externalappsListApps', options);
/**
 * List external apps
 * List external apps available to the current dashboard platform.
 */
export const externalappsListAppsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await externalappsListApps({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: externalappsListAppsQueryKey(options),
    });
};
export const externalappsGetAppQueryKey = (options) => createQueryKey('externalappsGetApp', options);
/**
 * Get external app
 * Retrieve a single external app available to the current dashboard platform.
 */
export const externalappsGetAppOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await externalappsGetApp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: externalappsGetAppQueryKey(options),
    });
};
/**
 * Update dashboard user
 * Update a dashboard user's profile information.
 */
export const dashboardUserUpdateDashboardUserMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await dashboardUserUpdateDashboardUser({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const roleAssignRoleQueryKey = (options) => createQueryKey('roleAssignRole', options);
/**
 * Assign a platform role to a dashboard user
 * Assign a platform role to a dashboard user.
 */
export const roleAssignRoleOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await roleAssignRole({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: roleAssignRoleQueryKey(options),
    });
};
/**
 * Assign a platform role to a dashboard user
 * Assign a platform role to a dashboard user.
 */
export const roleAssignRoleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await roleAssignRole({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const dashboardUserListInvitesQueryKey = (options) => createQueryKey('dashboardUserListInvites', options);
/**
 * List invites for a dashboard user
 * List pending platform invites sent to a dashboard user's email.
 */
export const dashboardUserListInvitesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dashboardUserListInvites({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dashboardUserListInvitesQueryKey(options),
    });
};
export const dashboardUserListPlatformRolesQueryKey = (options) => createQueryKey('dashboardUserListPlatformRoles', options);
/**
 * List platform roles for a dashboard user
 * List the platform roles assigned to a dashboard user.
 */
export const dashboardUserListPlatformRolesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dashboardUserListPlatformRoles({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dashboardUserListPlatformRolesQueryKey(options),
    });
};
export const dashboardUserGetDashboardUserPlatformModeSettingsQueryKey = (options) => createQueryKey('dashboardUserGetDashboardUserPlatformModeSettings', options);
/**
 * Get dashboard user platform mode settings
 * Retrieve platform-mode dashboard settings for the current dashboard user.
 */
export const dashboardUserGetDashboardUserPlatformModeSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dashboardUserGetDashboardUserPlatformModeSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dashboardUserGetDashboardUserPlatformModeSettingsQueryKey(options),
    });
};
/**
 * Update dashboard user platform mode settings
 * Update platform-mode dashboard settings for the current dashboard user.
 */
export const dashboardUserUpdateDashboardUserPlatformModeSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await dashboardUserUpdateDashboardUserPlatformModeSettings({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const dashboardUserGetDashboardUserSettingsQueryKey = (options) => createQueryKey('dashboardUserGetDashboardUserSettings', options);
/**
 * Get dashboard user settings
 * Retrieve settings for the current dashboard user.
 */
export const dashboardUserGetDashboardUserSettingsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await dashboardUserGetDashboardUserSettings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: dashboardUserGetDashboardUserSettingsQueryKey(options),
    });
};
/**
 * Update dashboard user settings
 * Update settings for the current dashboard user.
 */
export const dashboardUserUpdateDashboardUserSettingsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await dashboardUserUpdateDashboardUserSettings({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const helpSubmitQueryKey = (options) => createQueryKey('helpSubmit', options);
/**
 * Report suspicious agent input
 * Report potentially malicious instructions encountered by an automated agent.
 */
export const helpSubmitOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await helpSubmit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: helpSubmitQueryKey(options),
    });
};
/**
 * Report suspicious agent input
 * Report potentially malicious instructions encountered by an automated agent.
 */
export const helpSubmitMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await helpSubmit({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const inviteListInvitesQueryKey = (options) => createQueryKey('inviteListInvites', options);
/**
 * List invites
 * List pending dashboard invites.
 */
export const inviteListInvitesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await inviteListInvites({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: inviteListInvitesQueryKey(options),
    });
};
export const inviteCreatePlatformInviteQueryKey = (options) => createQueryKey('inviteCreatePlatformInvite', options);
/**
 * Create platform invite
 * Create a dashboard invite for a platform.
 */
export const inviteCreatePlatformInviteOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await inviteCreatePlatformInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: inviteCreatePlatformInviteQueryKey(options),
    });
};
/**
 * Create platform invite
 * Create a dashboard invite for a platform.
 */
export const inviteCreatePlatformInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await inviteCreatePlatformInvite({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete invite
 * Delete a dashboard invite by email.
 */
export const inviteDeleteInviteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await inviteDeleteInvite({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const inviteResendInviteEmailQueryKey = (options) => createQueryKey('inviteResendInviteEmail', options);
/**
 * Resend invite email
 * Resend a dashboard invite email.
 */
export const inviteResendInviteEmailOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await inviteResendInviteEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: inviteResendInviteEmailQueryKey(options),
    });
};
/**
 * Resend invite email
 * Resend a dashboard invite email.
 */
export const inviteResendInviteEmailMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await inviteResendInviteEmail({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const loginConfirmLoginEmailChallengeQueryKey = (options) => createQueryKey('loginConfirmLoginEmailChallenge', options);
/**
 * Confirm an email login challenge
 * Redeem a single-use email challenge and create an authenticated dashboard session.
 */
export const loginConfirmLoginEmailChallengeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await loginConfirmLoginEmailChallenge({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: loginConfirmLoginEmailChallengeQueryKey(options),
    });
};
/**
 * Confirm an email login challenge
 * Redeem a single-use email challenge and create an authenticated dashboard session.
 */
export const loginConfirmLoginEmailChallengeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await loginConfirmLoginEmailChallenge({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const onboardingGetDependencyGraphValuesQueryKey = (options) => createQueryKey('onboardingGetDependencyGraphValues', options);
/**
 * Get dependency graph values
 * Retrieve onboarding dependency graph values.
 */
export const onboardingGetDependencyGraphValuesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await onboardingGetDependencyGraphValues({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: onboardingGetDependencyGraphValuesQueryKey(options),
    });
};
/**
 * Update dependency graph values
 * Update onboarding dependency graph values.
 */
export const onboardingUpdateDependencyGraphValuesMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await onboardingUpdateDependencyGraphValues({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const onboardingUploadFileQueryKey = (options) => createQueryKey('onboardingUploadFile', options);
/**
 * Upload onboarding file
 * Upload a file for onboarding.
 */
export const onboardingUploadFileOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await onboardingUploadFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: onboardingUploadFileQueryKey(options),
    });
};
/**
 * Upload onboarding file
 * Upload a file for onboarding.
 */
export const onboardingUploadFileMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await onboardingUploadFile({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformGetPlatformQueryKey = (options) => createQueryKey('platformGetPlatform', options);
/**
 * Get platform
 * Retrieve platform details.
 */
export const platformGetPlatformOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformGetPlatform({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformGetPlatformQueryKey(options),
    });
};
/**
 * Update platform
 * Update platform details.
 */
export const platformUpdatePlatformMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await platformUpdatePlatform({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const apikeyListApiKeysQueryKey = (options) => createQueryKey('apikeyListApiKeys', options);
/**
 * List API keys
 * List API keys for the specified platform.
 */
export const apikeyListApiKeysOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apikeyListApiKeys({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: apikeyListApiKeysQueryKey(options),
    });
};
/**
 * Delete API key
 * Delete an API key by its ID.
 */
export const apikeyDeleteApiKeyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await apikeyDeleteApiKey({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const apikeyGetApiKeyQueryKey = (options) => createQueryKey('apikeyGetApiKey', options);
/**
 * Get API key
 * Retrieve a single API key by its ID.
 */
export const apikeyGetApiKeyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apikeyGetApiKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: apikeyGetApiKeyQueryKey(options),
    });
};
/**
 * Update API key
 * Update an API key by its ID.
 */
export const apikeyUpdateApiKeyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await apikeyUpdateApiKey({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const apikeyRevealApiKeyQueryKey = (options) => createQueryKey('apikeyRevealApiKey', options);
/**
 * Reveal API key
 * Retrieve the full API key token. Requires step-up verification.
 */
export const apikeyRevealApiKeyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await apikeyRevealApiKey({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: apikeyRevealApiKeyQueryKey(options),
    });
};
export const documentsListPlatformDocumentsQueryKey = (options) => createQueryKey('documentsListPlatformDocuments', options);
/**
 * List platform documents
 * List platform documents.
 */
export const documentsListPlatformDocumentsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await documentsListPlatformDocuments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: documentsListPlatformDocumentsQueryKey(options),
    });
};
export const documentsUploadPlatformDocumentQueryKey = (options) => createQueryKey('documentsUploadPlatformDocument', options);
/**
 * Upload platform document
 * Upload a platform document.
 */
export const documentsUploadPlatformDocumentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await documentsUploadPlatformDocument({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: documentsUploadPlatformDocumentQueryKey(options),
    });
};
/**
 * Upload platform document
 * Upload a platform document.
 */
export const documentsUploadPlatformDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await documentsUploadPlatformDocument({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const documentsGetPlatformDocumentQueryKey = (options) => createQueryKey('documentsGetPlatformDocument', options);
/**
 * Get document
 * Retrieve a platform document by ID.
 */
export const documentsGetPlatformDocumentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await documentsGetPlatformDocument({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: documentsGetPlatformDocumentQueryKey(options),
    });
};
export const platformGetPlatformMetadataQueryKey = (options) => createQueryKey('platformGetPlatformMetadata', options);
/**
 * Get platform metadata
 * Retrieve platform metadata.
 */
export const platformGetPlatformMetadataOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformGetPlatformMetadata({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformGetPlatformMetadataQueryKey(options),
    });
};
/**
 * Update platform metadata
 * Update platform metadata.
 */
export const platformUpdatePlatformMetadataMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await platformUpdatePlatformMetadata({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityEntityGetRootEntityQueryKey = (options) => createQueryKey('identityEntityGetRootEntity', options);
/**
 * Get root entity
 * Retrieve a platform's root entity.
 */
export const identityEntityGetRootEntityOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityGetRootEntity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityGetRootEntityQueryKey(options),
    });
};
export const identityEntityCreateBusinessRootEntityQueryKey = (options) => createQueryKey('identityEntityCreateBusinessRootEntity', options);
/**
 * Create business root entity
 * Create a business root entity for a platform.
 */
export const identityEntityCreateBusinessRootEntityOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityCreateBusinessRootEntity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityCreateBusinessRootEntityQueryKey(options),
    });
};
/**
 * Create business root entity
 * Create a business root entity for a platform.
 */
export const identityEntityCreateBusinessRootEntityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityCreateBusinessRootEntity({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityEntityCreatePersonRootEntityQueryKey = (options) => createQueryKey('identityEntityCreatePersonRootEntity', options);
/**
 * Create person root entity
 * Create a person root entity for a platform.
 */
export const identityEntityCreatePersonRootEntityOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityCreatePersonRootEntity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityCreatePersonRootEntityQueryKey(options),
    });
};
/**
 * Create person root entity
 * Create a person root entity for a platform.
 */
export const identityEntityCreatePersonRootEntityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityCreatePersonRootEntity({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const platformGetPlatformModeConfigQueryKey = (options) => createQueryKey('platformGetPlatformModeConfig', options);
/**
 * Get platform mode config
 * Retrieve configuration for the current platform mode.
 */
export const platformGetPlatformModeConfigOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await platformGetPlatformModeConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: platformGetPlatformModeConfigQueryKey(options),
    });
};
/**
 * Update platform mode config
 * Update configuration for the current platform mode.
 */
export const platformUpdatePlatformModeConfigMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await platformUpdatePlatformModeConfig({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferTemplateListPlatformTransferTemplatesQueryKey = (options) => createQueryKey('transferTemplateListPlatformTransferTemplates', options);
/**
 * List platform transfer templates
 * List transfer templates for the current platform.
 */
export const transferTemplateListPlatformTransferTemplatesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferTemplateListPlatformTransferTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferTemplateListPlatformTransferTemplatesQueryKey(options),
    });
};
export const transferTemplateCreatePlatformTransferTemplateQueryKey = (options) => createQueryKey('transferTemplateCreatePlatformTransferTemplate', options);
/**
 * Create platform transfer template
 * Create a transfer template for the current platform.
 */
export const transferTemplateCreatePlatformTransferTemplateOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferTemplateCreatePlatformTransferTemplate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferTemplateCreatePlatformTransferTemplateQueryKey(options),
    });
};
/**
 * Create platform transfer template
 * Create a transfer template for the current platform.
 */
export const transferTemplateCreatePlatformTransferTemplateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferTemplateCreatePlatformTransferTemplate({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete platform transfer template
 * Delete a transfer template by ID.
 */
export const transferTemplateDeletePlatformTransferTemplateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferTemplateDeletePlatformTransferTemplate({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferTemplateGetPlatformTransferTemplateQueryKey = (options) => createQueryKey('transferTemplateGetPlatformTransferTemplate', options);
/**
 * Get platform transfer template
 * Retrieve a transfer template by ID.
 */
export const transferTemplateGetPlatformTransferTemplateOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferTemplateGetPlatformTransferTemplate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferTemplateGetPlatformTransferTemplateQueryKey(options),
    });
};
/**
 * Update platform transfer template
 * Update a transfer template by ID.
 */
export const transferTemplateUpdatePlatformTransferTemplateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferTemplateUpdatePlatformTransferTemplate({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const roleListRolesQueryKey = (options) => createQueryKey('roleListRoles', options);
/**
 * List roles
 * List all roles (platform and custom) available on the platform.
 */
export const roleListRolesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await roleListRoles({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: roleListRolesQueryKey(options),
    });
};
export const roleCreateCustomRoleQueryKey = (options) => createQueryKey('roleCreateCustomRole', options);
/**
 * Create a custom role
 * Create a new custom role with a defined set of permissions.
 */
export const roleCreateCustomRoleOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await roleCreateCustomRole({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: roleCreateCustomRoleQueryKey(options),
    });
};
/**
 * Create a custom role
 * Create a new custom role with a defined set of permissions.
 */
export const roleCreateCustomRoleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await roleCreateCustomRole({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a custom role
 * Delete a custom role by its ID.
 */
export const roleDeleteCustomRoleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await roleDeleteCustomRole({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const roleGetCustomRoleQueryKey = (options) => createQueryKey('roleGetCustomRole', options);
/**
 * Get a custom role
 * Retrieve a single custom role by its ID.
 */
export const roleGetCustomRoleOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await roleGetCustomRole({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: roleGetCustomRoleQueryKey(options),
    });
};
/**
 * Update a custom role
 * Update the permissions assigned to a custom role.
 */
export const roleUpdateCustomRoleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await roleUpdateCustomRole({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ssoLoginCallbackQueryKey = (options) => createQueryKey('ssoLoginCallback', options);
/**
 * Complete SSO login
 * OIDC redirect target. Signs in the identity provider's user and redirects to the dashboard.
 */
export const ssoLoginCallbackOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ssoLoginCallback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ssoLoginCallbackQueryKey(options),
    });
};
export const ssoListConnectionsQueryKey = (options) => createQueryKey('ssoListConnections', options);
/**
 * List SSO connections
 * List SSO connections for the current dashboard platform.
 */
export const ssoListConnectionsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ssoListConnections({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ssoListConnectionsQueryKey(options),
    });
};
export const ssoCreateConnectionQueryKey = (options) => createQueryKey('ssoCreateConnection', options);
/**
 * Create SSO connection
 * Create an OIDC SSO connection for the current dashboard platform. New connections start with mode `off`.
 */
export const ssoCreateConnectionOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ssoCreateConnection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ssoCreateConnectionQueryKey(options),
    });
};
/**
 * Create SSO connection
 * Create an OIDC SSO connection for the current dashboard platform. New connections start with mode `off`.
 */
export const ssoCreateConnectionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await ssoCreateConnection({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete SSO connection
 * Delete an SSO connection and its domains. Existing SSO sessions stay valid until they expire.
 */
export const ssoDeleteConnectionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await ssoDeleteConnection({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ssoGetConnectionQueryKey = (options) => createQueryKey('ssoGetConnection', options);
/**
 * Get SSO connection
 * Retrieve an SSO connection for the current dashboard platform.
 */
export const ssoGetConnectionOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ssoGetConnection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ssoGetConnectionQueryKey(options),
    });
};
/**
 * Update SSO connection
 * Update an SSO connection for the current dashboard platform. Omitted fields keep their stored values. Changing `issuer`, `client_id` or `client_secret` clears `last_tested_at`. Mode `required` needs a tested connection and a verified domain.
 */
export const ssoUpdateConnectionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await ssoUpdateConnection({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ssoCreateDomainQueryKey = (options) => createQueryKey('ssoCreateDomain', options);
/**
 * Add SSO domain
 * Claim an email domain for an SSO connection. Returns the DNS TXT record to publish for verification.
 */
export const ssoCreateDomainOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ssoCreateDomain({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ssoCreateDomainQueryKey(options),
    });
};
/**
 * Add SSO domain
 * Claim an email domain for an SSO connection. Returns the DNS TXT record to publish for verification.
 */
export const ssoCreateDomainMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await ssoCreateDomain({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete SSO domain
 * Remove a domain from an SSO connection.
 */
export const ssoDeleteDomainMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await ssoDeleteDomain({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ssoVerifyDomainQueryKey = (options) => createQueryKey('ssoVerifyDomain', options);
/**
 * Verify SSO domain
 * Verify an SSO domain by looking up its DNS TXT record.
 */
export const ssoVerifyDomainOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ssoVerifyDomain({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ssoVerifyDomainQueryKey(options),
    });
};
/**
 * Verify SSO domain
 * Verify an SSO domain by looking up its DNS TXT record.
 */
export const ssoVerifyDomainMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await ssoVerifyDomain({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const ssoInitiateLoginQueryKey = (options) => createQueryKey('ssoInitiateLogin', options);
/**
 * Initiate SSO login
 * Redirect to the identity provider for an SSO connection, found by connection ID.
 */
export const ssoInitiateLoginOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ssoInitiateLogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ssoInitiateLoginQueryKey(options),
    });
};
export const ssoInitiateLoginFormQueryKey = (options) => createQueryKey('ssoInitiateLoginForm', options);
/**
 * Initiate SSO login
 * Redirect to the identity provider for an SSO connection, found by connection ID or email domain.
 */
export const ssoInitiateLoginFormOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await ssoInitiateLoginForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: ssoInitiateLoginFormQueryKey(options),
    });
};
/**
 * Initiate SSO login
 * Redirect to the identity provider for an SSO connection, found by connection ID or email domain.
 */
export const ssoInitiateLoginFormMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await ssoInitiateLoginForm({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webauthnBeginLoginQueryKey = (options) => createQueryKey('webauthnBeginLogin', options);
/**
 * Begin passkey login
 * Create usernameless WebAuthn login options using discoverable credentials.
 */
export const webauthnBeginLoginOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webauthnBeginLogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webauthnBeginLoginQueryKey(options),
    });
};
/**
 * Begin passkey login
 * Create usernameless WebAuthn login options using discoverable credentials.
 */
export const webauthnBeginLoginMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webauthnBeginLogin({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webauthnFinishLoginQueryKey = (options) => createQueryKey('webauthnFinishLogin', options);
/**
 * Finish passkey login
 * Verify a WebAuthn assertion and create an authenticated dashboard session.
 */
export const webauthnFinishLoginOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webauthnFinishLogin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webauthnFinishLoginQueryKey(options),
    });
};
/**
 * Finish passkey login
 * Verify a WebAuthn assertion and create an authenticated dashboard session.
 */
export const webauthnFinishLoginMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webauthnFinishLogin({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webauthnBeginRegistrationQueryKey = (options) => createQueryKey('webauthnBeginRegistration', options);
/**
 * Begin passkey registration
 * Create WebAuthn registration options for the authenticated dashboard user.
 */
export const webauthnBeginRegistrationOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webauthnBeginRegistration({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webauthnBeginRegistrationQueryKey(options),
    });
};
/**
 * Begin passkey registration
 * Create WebAuthn registration options for the authenticated dashboard user.
 */
export const webauthnBeginRegistrationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webauthnBeginRegistration({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webauthnFinishRegistrationQueryKey = (options) => createQueryKey('webauthnFinishRegistration', options);
/**
 * Finish passkey registration
 * Verify a WebAuthn attestation and create a passkey authentication factor.
 */
export const webauthnFinishRegistrationOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webauthnFinishRegistration({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webauthnFinishRegistrationQueryKey(options),
    });
};
/**
 * Finish passkey registration
 * Verify a WebAuthn attestation and create a passkey authentication factor.
 */
export const webauthnFinishRegistrationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webauthnFinishRegistration({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const documentsListDocumentsQueryKey = (options) => createQueryKey('documentsListDocuments', options);
/**
 * List all documents
 * List all documents under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const documentsListDocumentsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await documentsListDocuments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: documentsListDocumentsQueryKey(options),
    });
};
export const documentsUploadRegularDocumentQueryKey = (options) => createQueryKey('documentsUploadRegularDocument', options);
/**
 * Upload a document
 * To upload a file to Column, you will need to send a request with `Content-Type: multipart/form-data`. The request should contain the file you would like to upload, as well as other metadata. The `type` field cannot be `card_dispute_evidence`: card dispute evidence documents are uploaded via `POST /issuing/card-disputes/documents`.
 */
export const documentsUploadRegularDocumentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await documentsUploadRegularDocument({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: documentsUploadRegularDocumentQueryKey(options),
    });
};
/**
 * Upload a document
 * To upload a file to Column, you will need to send a request with `Content-Type: multipart/form-data`. The request should contain the file you would like to upload, as well as other metadata. The `type` field cannot be `card_dispute_evidence`: card dispute evidence documents are uploaded via `POST /issuing/card-disputes/documents`.
 */
export const documentsUploadRegularDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await documentsUploadRegularDocument({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const documentsGetDocumentQueryKey = (options) => createQueryKey('documentsGetDocument', options);
/**
 * Get a document
 * Retrieves the details of an existing document.
 */
export const documentsGetDocumentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await documentsGetDocument({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: documentsGetDocumentQueryKey(options),
    });
};
export const identityEntityGetEntitiesQueryKey = (options) => createQueryKey('identityEntityGetEntities', options);
/**
 * List all entities
 * Retrieve all entities on your platform. Filtered results can be retrieved with extra parameters in the query (`type`, `name`, etc.).
 */
export const identityEntityGetEntitiesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityGetEntities({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityGetEntitiesQueryKey(options),
    });
};
/**
 * Delete an entity
 * Delete the underlying entity.
 */
export const identityEntityDeleteEntityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityDeleteEntity({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityEntityGetEntityQueryKey = (options) => createQueryKey('identityEntityGetEntity', options);
/**
 * Get an entity by ID
 * Retrieve a single legal entity by its ID.
 */
export const identityEntityGetEntityOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityGetEntity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityGetEntityQueryKey(options),
    });
};
export const identityEntityGetAdditionalRequirementsQueryKey = (options) => createQueryKey('identityEntityGetAdditionalRequirements', options);
/**
 * Get additional requirements
 * Retrieve submitted additional requirements for an entity.
 */
export const identityEntityGetAdditionalRequirementsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityGetAdditionalRequirements({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityGetAdditionalRequirementsQueryKey(options),
    });
};
export const identityEntitySubmitAdditionalRequirementsQueryKey = (options) => createQueryKey('identityEntitySubmitAdditionalRequirements', options);
/**
 * Submit additional requirements
 * Submit additional requirements that may be configured as part of your compliance program at Column.
 */
export const identityEntitySubmitAdditionalRequirementsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntitySubmitAdditionalRequirements({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntitySubmitAdditionalRequirementsQueryKey(options),
    });
};
/**
 * Submit additional requirements
 * Submit additional requirements that may be configured as part of your compliance program at Column.
 */
export const identityEntitySubmitAdditionalRequirementsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntitySubmitAdditionalRequirements({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityEntityGetAssociatedPersonsQueryKey = (options) => createQueryKey('identityEntityGetAssociatedPersons', options);
/**
 * List associated persons
 * List the associated persons for a business entity. Results are paginated newest-first; use `limit` (default 10, max 100) with the `starting_after` / `ending_before` person entity ID cursors to page through businesses with many associated persons.
 */
export const identityEntityGetAssociatedPersonsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityGetAssociatedPersons({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityGetAssociatedPersonsQueryKey(options),
    });
};
export const identityEntityLinkAssociatedPersonQueryKey = (options) => createQueryKey('identityEntityLinkAssociatedPerson', options);
/**
 * Link an associated person
 * Link a person entity as an associated person to a business entity.
 */
export const identityEntityLinkAssociatedPersonOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityLinkAssociatedPerson({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityLinkAssociatedPersonQueryKey(options),
    });
};
/**
 * Link an associated person
 * Link a person entity as an associated person to a business entity.
 */
export const identityEntityLinkAssociatedPersonMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityLinkAssociatedPerson({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Update associated persons
 * Update the associated persons for a business entity.
 */
export const identityEntityUpdateAssociatedPersonsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityUpdateAssociatedPersons({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityEntityGetEntityComplianceQueryKey = (options) => createQueryKey('identityEntityGetEntityCompliance', options);
/**
 * Get entity compliance
 * Retrieve a list of fields that are not yet populated on an entity based on the compliance requirements for your program. Column will work with you to define required fields given your specific use case.
 */
export const identityEntityGetEntityComplianceOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityGetEntityCompliance({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityGetEntityComplianceQueryKey(options),
    });
};
export const identityEntityGetEntityEvidenceQueryKey = (options) => createQueryKey('identityEntityGetEntityEvidence', options);
/**
 * Get entity evidence
 * Retrieve evidence for an entity with optional filtering.
 */
export const identityEntityGetEntityEvidenceOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityGetEntityEvidence({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityGetEntityEvidenceQueryKey(options),
    });
};
export const identityEntityCreateEntityEvidenceQueryKey = (options) => createQueryKey('identityEntityCreateEntityEvidence', options);
/**
 * Create entity evidence
 * Add evidence to an entity. Supports file, signature, and third-party JSON evidence — if your KYC provider sends you a JSON blob, pass it directly in `data` with `third_party_json` as the `evidence_type`. A single submission can cover several purposes at once: Column creates one evidence record per entry in `purposes`, all referencing the same underlying document or data.
 */
export const identityEntityCreateEntityEvidenceOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityCreateEntityEvidence({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityCreateEntityEvidenceQueryKey(options),
    });
};
/**
 * Create entity evidence
 * Add evidence to an entity. Supports file, signature, and third-party JSON evidence — if your KYC provider sends you a JSON blob, pass it directly in `data` with `third_party_json` as the `evidence_type`. A single submission can cover several purposes at once: Column creates one evidence record per entry in `purposes`, all referencing the same underlying document or data.
 */
export const identityEntityCreateEntityEvidenceMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityCreateEntityEvidence({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityEntityGetEntityNarrativesQueryKey = (options) => createQueryKey('identityEntityGetEntityNarratives', options);
/**
 * List entity narratives
 * Retrieve the narratives for an entity, newest first. Deleted narratives are excluded.
 */
export const identityEntityGetEntityNarrativesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityGetEntityNarratives({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityGetEntityNarrativesQueryKey(options),
    });
};
export const identityEntityCreateEntityNarrativeQueryKey = (options) => createQueryKey('identityEntityCreateEntityNarrative', options);
/**
 * Create an entity narrative
 * Append a free-form note to an entity's customer file, such as the context a reviewer records while collecting CIP/CDD documentation. Narratives are append-only: they cannot be edited after creation, only deleted as individual records.
 */
export const identityEntityCreateEntityNarrativeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityCreateEntityNarrative({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityCreateEntityNarrativeQueryKey(options),
    });
};
/**
 * Create an entity narrative
 * Append a free-form note to an entity's customer file, such as the context a reviewer records while collecting CIP/CDD documentation. Narratives are append-only: they cannot be edited after creation, only deleted as individual records.
 */
export const identityEntityCreateEntityNarrativeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityCreateEntityNarrative({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete an entity narrative
 * Remove a single narrative from an entity's customer file.
 */
export const identityEntityDeleteEntityNarrativeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityDeleteEntityNarrative({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityEntityCreateBusinessEntityQueryKey = (options) => createQueryKey('identityEntityCreateBusinessEntity', options);
/**
 * Create a business entity
 * Create a new business entity.
 */
export const identityEntityCreateBusinessEntityOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityCreateBusinessEntity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityCreateBusinessEntityQueryKey(options),
    });
};
/**
 * Create a business entity
 * Create a new business entity.
 */
export const identityEntityCreateBusinessEntityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityCreateBusinessEntity({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Update a business entity
 * Update an existing business entity.
 */
export const identityEntityUpdateBusinessEntityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityUpdateBusinessEntity({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const identityEntityCreatePersonEntityQueryKey = (options) => createQueryKey('identityEntityCreatePersonEntity', options);
/**
 * Create a person entity
 * Create a new person entity for individual customers.
 */
export const identityEntityCreatePersonEntityOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await identityEntityCreatePersonEntity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: identityEntityCreatePersonEntityQueryKey(options),
    });
};
/**
 * Create a person entity
 * Create a new person entity for individual customers.
 */
export const identityEntityCreatePersonEntityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityCreatePersonEntity({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Update a person entity
 * Update an existing person entity.
 */
export const identityEntityUpdatePersonEntityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await identityEntityUpdatePersonEntity({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const eventListEventsQueryKey = (options) => createQueryKey('eventListEvents', options);
/**
 * List all events
 * Lists all events, inclusive of events sent via webhooks.
 */
export const eventListEventsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await eventListEvents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: eventListEventsQueryKey(options),
    });
};
export const eventGetEventQueryKey = (options) => createQueryKey('eventGetEvent', options);
/**
 * Get an event
 * Retrieve a single event by its ID.
 */
export const eventGetEventOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await eventGetEvent({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: eventGetEventQueryKey(options),
    });
};
export const eventListWebhookEventsQueryKey = (options) => createQueryKey('eventListWebhookEvents', options);
/**
 * List all webhook events
 * Lists just the events that resulted in webhooks. Useful for reconciling webhooks.
 */
export const eventListWebhookEventsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await eventListWebhookEvents({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: eventListWebhookEventsQueryKey(options),
    });
};
export const financialInstitutionGetIbanQueryKey = (options) => createQueryKey('financialInstitutionGetIban', options);
/**
 * Validate an IBAN
 * Validate the format of an IBAN and check whether it is registered with the given financial institution. However, we cannot verify if the account is still open.
 */
export const financialInstitutionGetIbanOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await financialInstitutionGetIban({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: financialInstitutionGetIbanQueryKey(options),
    });
};
export const financialInstitutionListFinancialInstitutionsQueryKey = (options) => createQueryKey('financialInstitutionListFinancialInstitutions', options);
/**
 * List financial institutions
 * List all financial institutions. Filtered results can be retrieved with extra parameters in your queries.
 */
export const financialInstitutionListFinancialInstitutionsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await financialInstitutionListFinancialInstitutions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: financialInstitutionListFinancialInstitutionsQueryKey(options),
    });
};
export const financialInstitutionGetFinancialInstitutionQueryKey = (options) => createQueryKey('financialInstitutionGetFinancialInstitution', options);
/**
 * Get a financial institution
 * Retrieve a single financial institution by its ABA number or BIC.
 */
export const financialInstitutionGetFinancialInstitutionOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await financialInstitutionGetFinancialInstitution({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: financialInstitutionGetFinancialInstitutionQueryKey(options),
    });
};
export const interestsListConfigsQueryKey = (options) => createQueryKey('interestsListConfigs', options);
/**
 * List interest configs
 * Retrieve multiple interest configs on your platform.
 */
export const interestsListConfigsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsListConfigs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsListConfigsQueryKey(options),
    });
};
export const interestsCreateConfigQueryKey = (options) => createQueryKey('interestsCreateConfig', options);
/**
 * Create interest config
 * Create an interest configuration for your platform.
 */
export const interestsCreateConfigOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsCreateConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsCreateConfigQueryKey(options),
    });
};
/**
 * Create interest config
 * Create an interest configuration for your platform.
 */
export const interestsCreateConfigMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await interestsCreateConfig({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const interestsGetConfigQueryKey = (options) => createQueryKey('interestsGetConfig', options);
/**
 * Get interest config
 * Retrieve a single interest config by its ID.
 */
export const interestsGetConfigOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsGetConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsGetConfigQueryKey(options),
    });
};
export const interestsUpdateConfigQueryKey = (options) => createQueryKey('interestsUpdateConfig', options);
/**
 * Update interest config
 * Update an interest config.
 */
export const interestsUpdateConfigOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsUpdateConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsUpdateConfigQueryKey(options),
    });
};
/**
 * Update interest config
 * Update an interest config.
 */
export const interestsUpdateConfigMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await interestsUpdateConfig({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const interestsListPayoutsQueryKey = (options) => createQueryKey('interestsListPayouts', options);
/**
 * List interest payouts
 * Retrieve multiple interest payouts of your platform.
 */
export const interestsListPayoutsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsListPayouts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsListPayoutsQueryKey(options),
    });
};
export const interestsGetPayoutQueryKey = (options) => createQueryKey('interestsGetPayout', options);
/**
 * Get interest payout
 * Retrieve a single interest payout by its ID.
 */
export const interestsGetPayoutOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsGetPayout({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsGetPayoutQueryKey(options),
    });
};
export const interestsListPivotRatesQueryKey = (options) => createQueryKey('interestsListPivotRates', options);
/**
 * List pivot interest rates
 * Retrieve multiple pivot interest rates.
 */
export const interestsListPivotRatesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsListPivotRates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsListPivotRatesQueryKey(options),
    });
};
export const interestsCreatePivotRateQueryKey = (options) => createQueryKey('interestsCreatePivotRate', options);
/**
 * Create pivot interest rate
 * Create a pivot interest rate for your platform.
 */
export const interestsCreatePivotRateOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsCreatePivotRate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsCreatePivotRateQueryKey(options),
    });
};
/**
 * Create pivot interest rate
 * Create a pivot interest rate for your platform.
 */
export const interestsCreatePivotRateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await interestsCreatePivotRate({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete pivot interest rate
 * Delete a pivot interest rate.
 */
export const interestsDeletePivotRateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await interestsDeletePivotRate({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const interestsGetPivotRateQueryKey = (options) => createQueryKey('interestsGetPivotRate', options);
/**
 * Get pivot interest rate
 * Retrieve a single pivot interest rate by its ID.
 */
export const interestsGetPivotRateOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsGetPivotRate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsGetPivotRateQueryKey(options),
    });
};
export const interestsUpdatePivotRateQueryKey = (options) => createQueryKey('interestsUpdatePivotRate', options);
/**
 * Update pivot interest rate
 * Update a pivot interest rate before 4:00pm PST on its effective date.
 */
export const interestsUpdatePivotRateOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsUpdatePivotRate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsUpdatePivotRateQueryKey(options),
    });
};
/**
 * Update pivot interest rate
 * Update a pivot interest rate before 4:00pm PST on its effective date.
 */
export const interestsUpdatePivotRateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await interestsUpdatePivotRate({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsListCardAccountsQueryKey = (options) => createQueryKey('cardsListCardAccounts', options);
/**
 * List card accounts
 * Retrieve a list of card accounts.
 */
export const cardsListCardAccountsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsListCardAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsListCardAccountsQueryKey(options),
    });
};
export const cardsCreateCardAccountQueryKey = (options) => createQueryKey('cardsCreateCardAccount', options);
/**
 * Create card account
 * Create a new card account.
 */
export const cardsCreateCardAccountOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCreateCardAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCreateCardAccountQueryKey(options),
    });
};
/**
 * Create card account
 * Create a new card account.
 */
export const cardsCreateCardAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCreateCardAccount({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsGetCardAccountQueryKey = (options) => createQueryKey('cardsGetCardAccount', options);
/**
 * Get card account by ID
 * Retrieve detailed information about a specific card account.
 */
export const cardsGetCardAccountOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsGetCardAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsGetCardAccountQueryKey(options),
    });
};
/**
 * Close card account
 * Permanently close an `open` card account. Fires an `issuing.card_account.closed` event. With `deactivate_cards_and_card_tokens`, its cards and card tokens are deactivated and fire their own events.
 */
export const cardsCloseCardAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCloseCardAccount({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Reinstate card account
 * Reinstate a previously suspended card account. Fires an `issuing.card_account.reinstated` event. Cards paused by the suspension stay paused until you activate them.
 */
export const cardsReinstateCardAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsReinstateCardAccount({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Suspend card account
 * Suspend an `open` card account and pause its active cards. Fires an `issuing.card_account.suspended` event, and an `issuing.card.paused` event for each card it pauses.
 */
export const cardsSuspendCardAccountMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSuspendCardAccount({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsCreateCardAuthorizationPolicyQueryKey = (options) => createQueryKey('cardsCreateCardAuthorizationPolicy', options);
/**
 * Create card authorization policy
 * Create a new card authorization policy and its initial version.
 */
export const cardsCreateCardAuthorizationPolicyOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCreateCardAuthorizationPolicy({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCreateCardAuthorizationPolicyQueryKey(options),
    });
};
/**
 * Create card authorization policy
 * Create a new card authorization policy and its initial version.
 */
export const cardsCreateCardAuthorizationPolicyMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCreateCardAuthorizationPolicy({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsListCardAuthorizationPolicyVersionsQueryKey = (options) => createQueryKey('cardsListCardAuthorizationPolicyVersions', options);
/**
 * List card authorization policy versions
 * Retrieve a list of versions for the specified card authorization policy.
 */
export const cardsListCardAuthorizationPolicyVersionsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsListCardAuthorizationPolicyVersions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsListCardAuthorizationPolicyVersionsQueryKey(options),
    });
};
export const cardsCreateCardAuthorizationPolicyVersionQueryKey = (options) => createQueryKey('cardsCreateCardAuthorizationPolicyVersion', options);
/**
 * Create card authorization policy version
 * Create a new version for an existing card authorization policy.
 */
export const cardsCreateCardAuthorizationPolicyVersionOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCreateCardAuthorizationPolicyVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCreateCardAuthorizationPolicyVersionQueryKey(options),
    });
};
/**
 * Create card authorization policy version
 * Create a new version for an existing card authorization policy.
 */
export const cardsCreateCardAuthorizationPolicyVersionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCreateCardAuthorizationPolicyVersion({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete card authorization policy version
 * Delete a specific card authorization policy version.
 */
export const cardsDeleteCardAuthorizationPolicyVersionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsDeleteCardAuthorizationPolicyVersion({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsGetCardAuthorizationPolicyVersionQueryKey = (options) => createQueryKey('cardsGetCardAuthorizationPolicyVersion', options);
/**
 * Get card authorization policy version
 * Retrieve a specific card authorization policy version by its ID.
 */
export const cardsGetCardAuthorizationPolicyVersionOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsGetCardAuthorizationPolicyVersion({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsGetCardAuthorizationPolicyVersionQueryKey(options),
    });
};
/**
 * Update card authorization policy version
 * Update a specific card authorization policy version.
 */
export const cardsUpdateCardAuthorizationPolicyVersionMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsUpdateCardAuthorizationPolicyVersion({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsCheckCardDisputeEligibilityQueryKey = (options) => createQueryKey('cardsCheckCardDisputeEligibility', options);
/**
 * Check card dispute eligibility
 * Check whether a card transaction can be disputed without creating a dispute.
 */
export const cardsCheckCardDisputeEligibilityOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCheckCardDisputeEligibility({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCheckCardDisputeEligibilityQueryKey(options),
    });
};
/**
 * Check card dispute eligibility
 * Check whether a card transaction can be disputed without creating a dispute.
 */
export const cardsCheckCardDisputeEligibilityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCheckCardDisputeEligibility({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsListCardDisputesQueryKey = (options) => createQueryKey('cardsListCardDisputes', options);
/**
 * List card disputes
 * Retrieve a list of card disputes.
 */
export const cardsListCardDisputesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsListCardDisputes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsListCardDisputesQueryKey(options),
    });
};
export const cardsCreateCardDisputeQueryKey = (options) => createQueryKey('cardsCreateCardDispute', options);
/**
 * Create card dispute
 * Create a local card dispute for a settled card transaction.
 */
export const cardsCreateCardDisputeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCreateCardDispute({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCreateCardDisputeQueryKey(options),
    });
};
/**
 * Create card dispute
 * Create a local card dispute for a settled card transaction.
 */
export const cardsCreateCardDisputeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCreateCardDispute({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsGetDisputeQueryKey = (options) => createQueryKey('cardsGetDispute', options);
/**
 * Get card dispute by ID
 * Retrieve detailed information about a specific card dispute.
 */
export const cardsGetDisputeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsGetDispute({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsGetDisputeQueryKey(options),
    });
};
export const cardsCloseCardDisputeQueryKey = (options) => createQueryKey('cardsCloseCardDispute', options);
/**
 * Close card dispute
 * Close a card dispute in the cardholder's favor (platform assumes liability) or as withdrawn by the cardholder. Submitted Visa disputes are recalled from the network first.
 */
export const cardsCloseCardDisputeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCloseCardDispute({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCloseCardDisputeQueryKey(options),
    });
};
/**
 * Close card dispute
 * Close a card dispute in the cardholder's favor (platform assumes liability) or as withdrawn by the cardholder. Submitted Visa disputes are recalled from the network first.
 */
export const cardsCloseCardDisputeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCloseCardDispute({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsAddCardDisputeEvidenceQueryKey = (options) => createQueryKey('cardsAddCardDisputeEvidence', options);
/**
 * Add card dispute evidence
 * Add document or narrative evidence to a card dispute.
 */
export const cardsAddCardDisputeEvidenceOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsAddCardDisputeEvidence({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsAddCardDisputeEvidenceQueryKey(options),
    });
};
/**
 * Add card dispute evidence
 * Add document or narrative evidence to a card dispute.
 */
export const cardsAddCardDisputeEvidenceMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsAddCardDisputeEvidence({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Remove card dispute provisional credit
 * Reverse a draft card dispute's provisional credit back into the card program's operating account and set `provisional_credit` to `false`. The reversal is recorded on the card transaction as a `dispute_credit_reversal` event. For a debit card program, the cardholder's bank account must still hold the credited funds. Repeating the request once the credit is removed changes nothing.
 */
export const cardsRemoveCardDisputeProvisionalCreditMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsRemoveCardDisputeProvisionalCredit({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsIssueCardDisputeProvisionalCreditQueryKey = (options) => createQueryKey('cardsIssueCardDisputeProvisionalCredit', options);
/**
 * Issue card dispute provisional credit
 * Credit the cardholder the dispute amount from the card program's operating account while the dispute is a draft. The credit is recorded on the card transaction as a `dispute_credit` event. Repeating the request while the credit is in place changes nothing. Not supported for `original_credit_not_accepted` disputes.
 */
export const cardsIssueCardDisputeProvisionalCreditOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsIssueCardDisputeProvisionalCredit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsIssueCardDisputeProvisionalCreditQueryKey(options),
    });
};
/**
 * Issue card dispute provisional credit
 * Credit the cardholder the dispute amount from the card program's operating account while the dispute is a draft. The credit is recorded on the card transaction as a `dispute_credit` event. Repeating the request while the credit is in place changes nothing. Not supported for `original_credit_not_accepted` disputes.
 */
export const cardsIssueCardDisputeProvisionalCreditMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsIssueCardDisputeProvisionalCredit({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsRespondCardDisputeQueryKey = (options) => createQueryKey('cardsRespondCardDispute', options);
/**
 * Respond to card dispute
 * Queue a response to the card network for the current dispute stage.
 */
export const cardsRespondCardDisputeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsRespondCardDispute({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsRespondCardDisputeQueryKey(options),
    });
};
/**
 * Respond to card dispute
 * Queue a response to the card network for the current dispute stage.
 */
export const cardsRespondCardDisputeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsRespondCardDispute({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSubmitCardDisputeQueryKey = (options) => createQueryKey('cardsSubmitCardDispute', options);
/**
 * Submit card dispute
 * Queue a local card dispute for network submission.
 */
export const cardsSubmitCardDisputeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSubmitCardDispute({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSubmitCardDisputeQueryKey(options),
    });
};
/**
 * Submit card dispute
 * Queue a local card dispute for network submission.
 */
export const cardsSubmitCardDisputeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSubmitCardDispute({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsUploadCardDisputeDocumentQueryKey = (options) => createQueryKey('cardsUploadCardDisputeDocument', options);
/**
 * Upload card dispute document
 * Upload a card dispute evidence document with a `Content-Type: multipart/form-data` request containing a `file` and optional `description` and `tag` fields. The `type` field is ignored: documents uploaded here are always `card_dispute_evidence` and are the only ones accepted as `document_id` when adding evidence to a card dispute. The response `url` expires after 60 seconds.
 */
export const cardsUploadCardDisputeDocumentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsUploadCardDisputeDocument({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsUploadCardDisputeDocumentQueryKey(options),
    });
};
/**
 * Upload card dispute document
 * Upload a card dispute evidence document with a `Content-Type: multipart/form-data` request containing a `file` and optional `description` and `tag` fields. The `type` field is ignored: documents uploaded here are always `card_dispute_evidence` and are the only ones accepted as `document_id` when adding evidence to a card dispute. The response `url` expires after 60 seconds.
 */
export const cardsUploadCardDisputeDocumentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsUploadCardDisputeDocument({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsGetCardDisputeDocumentQueryKey = (options) => createQueryKey('cardsGetCardDisputeDocument', options);
/**
 * Get card dispute document
 * Retrieve a card dispute evidence document by ID (platform-uploaded or Visa-returned evidence). The response `url` expires after 60 seconds.
 */
export const cardsGetCardDisputeDocumentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsGetCardDisputeDocument({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsGetCardDisputeDocumentQueryKey(options),
    });
};
export const cardsListCardProgramsQueryKey = (options) => createQueryKey('cardsListCardPrograms', options);
/**
 * List card programs
 * Retrieve a list of card programs.
 */
export const cardsListCardProgramsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsListCardPrograms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsListCardProgramsQueryKey(options),
    });
};
export const cardsGetCardProgramQueryKey = (options) => createQueryKey('cardsGetCardProgram', options);
/**
 * Get card program by ID
 * Retrieve detailed information about a specific card program.
 */
export const cardsGetCardProgramOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsGetCardProgram({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsGetCardProgramQueryKey(options),
    });
};
/**
 * Update card program
 * Update a card program.
 */
export const cardsUpdateCardProgramMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsUpdateCardProgram({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsListCardTemplatesQueryKey = (options) => createQueryKey('cardsListCardTemplates', options);
/**
 * List card templates
 * Retrieve the card templates a card program's physical cards can be created with. Pass a template's `id` as `card_template_id` when creating a physical card, or omit it to use the card program's `default_card_template_id`.
 */
export const cardsListCardTemplatesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsListCardTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsListCardTemplatesQueryKey(options),
    });
};
export const cardsListCardTokensQueryKey = (options) => createQueryKey('cardsListCardTokens', options);
/**
 * List card tokens
 * Retrieve a list of card tokens.
 */
export const cardsListCardTokensOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsListCardTokens({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsListCardTokensQueryKey(options),
    });
};
export const cardsGetCardTokenQueryKey = (options) => createQueryKey('cardsGetCardToken', options);
/**
 * Get card token by ID
 * Retrieve detailed information about a specific card token.
 */
export const cardsGetCardTokenOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsGetCardToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsGetCardTokenQueryKey(options),
    });
};
/**
 * Activate card token
 * Reactivate a paused card token. Only tokens in the `paused` status can be activated. Fires an `issuing.card_token.activated` event.
 */
export const cardsActivateCardTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsActivateCardToken({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Deactivate card token
 * Deactivate a card token so it can no longer be used. Any token that isn't already `deactivated` can be deactivated. A deactivated token can't be reactivated through the API, but Visa can re-provision it, which moves it back to `pending_activation`. Fires an `issuing.card_token.deactivated` event.
 */
export const cardsDeactivateCardTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsDeactivateCardToken({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Pause card token
 * Temporarily pause a card token. Authorizations with the token are declined until it is reactivated. Only tokens in the `active` status can be paused. Fires an `issuing.card_token.paused` event.
 */
export const cardsPauseCardTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsPauseCardToken({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsListCardTransactionsQueryKey = (options) => createQueryKey('cardsListCardTransactions', options);
/**
 * List card transactions
 * Retrieve a list of card transactions.
 */
export const cardsListCardTransactionsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsListCardTransactions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsListCardTransactionsQueryKey(options),
    });
};
export const cardsGetCardTransactionQueryKey = (options) => createQueryKey('cardsGetCardTransaction', options);
/**
 * Get card transaction by ID
 * Retrieve detailed information about a specific card transaction.
 */
export const cardsGetCardTransactionOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsGetCardTransaction({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsGetCardTransactionQueryKey(options),
    });
};
export const cardsListCardsQueryKey = (options) => createQueryKey('cardsListCards', options);
/**
 * List cards
 * Retrieve a list of cards.
 */
export const cardsListCardsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsListCards({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsListCardsQueryKey(options),
    });
};
export const cardsCreateCardQueryKey = (options) => createQueryKey('cardsCreateCard', options);
/**
 * Create card
 * Create a new card with a required card_account_id parameter.
 */
export const cardsCreateCardOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCreateCard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCreateCardQueryKey(options),
    });
};
/**
 * Create card
 * Create a new card with a required card_account_id parameter.
 */
export const cardsCreateCardMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCreateCard({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsGetCardQueryKey = (options) => createQueryKey('cardsGetCard', options);
/**
 * Get card
 * Retrieve detailed information about a specific card.
 */
export const cardsGetCardOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsGetCard({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsGetCardQueryKey(options),
    });
};
/**
 * Update card
 * Update a card's authorization policy.
 */
export const cardsUpdateCardMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsUpdateCard({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Activate card
 * Activate a card. A card can't be activated if any card with the same PAN was deactivated as `lost`, `stolen`, or `fraud`, or if it's a renewal whose original card was replaced by a different card.
 */
export const cardsActivateCardMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsActivateCard({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsAddCardToWalletQueryKey = (options) => createQueryKey('cardsAddCardToWallet', options);
/**
 * Add card to wallet
 * Create the encrypted provisioning payload your app passes to Apple Pay, Google Pay, or Samsung Pay to add a card to
 * the wallet. Provide exactly one of `apple_pay`, `google_pay`, or `samsung_pay`; the response carries the payload for
 * that wallet under the same key.
 *
 * The card must be `active` or `paused`, not expired, and its card account must be `open`. Only Visa cards are
 * supported; other networks return `card_not_supported_for_wallet`. In sandbox, `visa_sandbox` cards return
 * `feature_not_enabled`; use the simulate add card to wallet endpoint instead. Live mode returns `feature_not_enabled`
 * until add to wallet is enabled for your card program.
 *
 */
export const cardsAddCardToWalletOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsAddCardToWallet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsAddCardToWalletQueryKey(options),
    });
};
/**
 * Add card to wallet
 * Create the encrypted provisioning payload your app passes to Apple Pay, Google Pay, or Samsung Pay to add a card to
 * the wallet. Provide exactly one of `apple_pay`, `google_pay`, or `samsung_pay`; the response carries the payload for
 * that wallet under the same key.
 *
 * The card must be `active` or `paused`, not expired, and its card account must be `open`. Only Visa cards are
 * supported; other networks return `card_not_supported_for_wallet`. In sandbox, `visa_sandbox` cards return
 * `feature_not_enabled`; use the simulate add card to wallet endpoint instead. Live mode returns `feature_not_enabled`
 * until add to wallet is enabled for your card program.
 *
 */
export const cardsAddCardToWalletMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsAddCardToWallet({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Deactivate card
 * Permanently deactivate a card. The card's status changes to `deactivated` and cannot be reactivated. If the card has card tokens that aren't deactivated, set `deactivate_card_tokens` to `true` to deactivate them as well; otherwise the request is rejected.
 */
export const cardsDeactivateCardMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsDeactivateCard({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Pause card
 * Temporarily pause a card. The card's status changes to paused and all authorization requests will be declined until the card is resumed.
 */
export const cardsPauseCardMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsPauseCard({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete card PIN
 * Remove a debit card's PIN. Transactions that require a PIN decline until you set a new one with the update card PIN endpoint. Succeeds when the card has no PIN. A renewal copies the PIN when it is created, so deleting the PIN on the original card doesn't affect a renewed card that already exists.
 */
export const cardsDeleteCardPinMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsDeleteCardPin({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Update card PIN
 * Update a debit card's PIN.
 */
export const cardsUpdateCardPinMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsUpdateCardPin({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsUnblockCardPinQueryKey = (options) => createQueryKey('cardsUnblockCardPin', options);
/**
 * Unblock card PIN
 * Unblock a card's PIN without changing it, for example after you verify the cardholder. A PIN is blocked after 3 wrong PINs in a row on transactions. Unblocking clears the block and the count of wrong PINs, and sends an `issuing.card.pin_unblocked` event. Unblocking a card whose PIN isn't blocked succeeds without an event.
 */
export const cardsUnblockCardPinOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsUnblockCardPin({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsUnblockCardPinQueryKey(options),
    });
};
/**
 * Unblock card PIN
 * Unblock a card's PIN without changing it, for example after you verify the cardholder. A PIN is blocked after 3 wrong PINs in a row on transactions. Unblocking clears the block and the count of wrong PINs, and sends an `issuing.card.pin_unblocked` event. Unblocking a card whose PIN isn't blocked succeeds without an event.
 */
export const cardsUnblockCardPinMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsUnblockCardPin({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Renew card
 * Renew a card to extend its expiration date while keeping the same PAN. The card's `sequence_number` is incremented. Only `active` or `paused` cards can be renewed. A card can't be renewed while another card with the same PAN, such as an earlier renewal, isn't deactivated, or if any card with the same PAN was deactivated as `lost`, `stolen`, or `fraud`.
 */
export const cardsRenewCardMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsRenewCard({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Replace card
 * Replace a card and automatically deactivate the original. The response contains the new replacement card;
 * retrieve the original card to see its `deactivation_reason` and `replacement_card_id`.
 *
 * | Requested reason | PAN | Original card's recorded reason | Original card's tokens |
 * | --- | --- | --- | --- |
 * | `lost`, `stolen`, `fraud`, `voluntary` | New PAN | Requested reason | Deactivated |
 * | `damaged` | Reused | `damaged` | Deactivated |
 * | `expired` | Reused | `renewed` | Deactivated |
 *
 * All non-terminal tokens on the original card are deactivated for every replacement reason, including when the PAN
 * is reused. Reusing the PAN increments `sequence_number`. An `expired` replacement records `renewed` as the reason,
 * but does not preserve tokens. The separate renew endpoint migrates tokens when the renewal card is activated.
 * `renewed` and `account_closed` are not valid replacement request reasons and return HTTP 400. A card can't be
 * replaced as `damaged` or `expired` if any card with the same PAN was deactivated as `lost`, `stolen`, or `fraud`.
 */
export const cardsReplaceCardMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsReplaceCard({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsRevealCardDetailsQueryKey = (options) => createQueryKey('cardsRevealCardDetails', options);
/**
 * Reveal card details
 * Reveal a card's full details. Authenticate with a card reveal token instead of your API key, sent as `Authorization: Bearer <card_reveal_token_id>`. Create one with the create card reveal token endpoint; each token is single use, expires, and only works for the card it was created for.
 */
export const cardsRevealCardDetailsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsRevealCardDetails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsRevealCardDetailsQueryKey(options),
    });
};
export const cardsCreateCardRevealTokenQueryKey = (options) => createQueryKey('cardsCreateCardRevealToken', options);
/**
 * Create card reveal token
 * Create a reveal token for a card.
 */
export const cardsCreateCardRevealTokenOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCreateCardRevealToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCreateCardRevealTokenQueryKey(options),
    });
};
/**
 * Create card reveal token
 * Create a reveal token for a card.
 */
export const cardsCreateCardRevealTokenMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCreateCardRevealToken({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingLoanListLoansQueryKey = (options) => createQueryKey('lendingLoanListLoans', options);
/**
 * List all loans
 * List all loans under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const lendingLoanListLoansOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingLoanListLoans({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingLoanListLoansQueryKey(options),
    });
};
export const lendingLoanCreateLoanQueryKey = (options) => createQueryKey('lendingLoanCreateLoan', options);
/**
 * Create a new loan
 * Creates a new loan under an entity.
 */
export const lendingLoanCreateLoanOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingLoanCreateLoan({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingLoanCreateLoanQueryKey(options),
    });
};
/**
 * Create a new loan
 * Creates a new loan under an entity.
 */
export const lendingLoanCreateLoanMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingLoanCreateLoan({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingLoanGetLoanQueryKey = (options) => createQueryKey('lendingLoanGetLoan', options);
/**
 * Get a loan by ID
 * Retrieve a single loan by its ID.
 */
export const lendingLoanGetLoanOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingLoanGetLoan({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingLoanGetLoanQueryKey(options),
    });
};
/**
 * Update a loan
 * Updates a loan by its ID.
 */
export const lendingLoanUpdateLoanMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingLoanUpdateLoan({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingPaymentsApplyLoanCollateralQueryKey = (options) => createQueryKey('lendingPaymentsApplyLoanCollateral', options);
/**
 * Apply collateral
 * Apply locked collateral to the principal balance of a secured loan.
 */
export const lendingPaymentsApplyLoanCollateralOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingPaymentsApplyLoanCollateral({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingPaymentsApplyLoanCollateralQueryKey(options),
    });
};
/**
 * Apply collateral
 * Apply locked collateral to the principal balance of a secured loan.
 */
export const lendingPaymentsApplyLoanCollateralMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingPaymentsApplyLoanCollateral({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingLoanGetLoanHistoryQueryKey = (options) => createQueryKey('lendingLoanGetLoanHistory', options);
/**
 * Get loan summary history
 * Retrieve daily summary history for a specific loan. [Read more]({{lending.report}}).
 */
export const lendingLoanGetLoanHistoryOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingLoanGetLoanHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingLoanGetLoanHistoryQueryKey(options),
    });
};
export const lendingSaleCreateSaleQueryKey = (options) => createQueryKey('lendingSaleCreateSale', options);
/**
 * Create a loan sale
 * Creates a loan sale for a specific loan.
 */
export const lendingSaleCreateSaleOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingSaleCreateSale({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingSaleCreateSaleQueryKey(options),
    });
};
/**
 * Create a loan sale
 * Creates a loan sale for a specific loan.
 */
export const lendingSaleCreateSaleMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingSaleCreateSale({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingDisbursementsListDisbursementsQueryKey = (options) => createQueryKey('lendingDisbursementsListDisbursements', options);
/**
 * List all disbursements
 * List all disbursements under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const lendingDisbursementsListDisbursementsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingDisbursementsListDisbursements({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingDisbursementsListDisbursementsQueryKey(options),
    });
};
export const lendingDisbursementsCreateDisbursementQueryKey = (options) => createQueryKey('lendingDisbursementsCreateDisbursement', options);
/**
 * Create a disbursement
 * Creates a disbursement for a loan. [Read more]({{lending.report}}).
 */
export const lendingDisbursementsCreateDisbursementOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingDisbursementsCreateDisbursement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingDisbursementsCreateDisbursementQueryKey(options),
    });
};
/**
 * Create a disbursement
 * Creates a disbursement for a loan. [Read more]({{lending.report}}).
 */
export const lendingDisbursementsCreateDisbursementMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingDisbursementsCreateDisbursement({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingDisbursementsGetDisbursementQueryKey = (options) => createQueryKey('lendingDisbursementsGetDisbursement', options);
/**
 * Get a disbursement
 * Retrieve a single disbursement by its ID.
 */
export const lendingDisbursementsGetDisbursementOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingDisbursementsGetDisbursement({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingDisbursementsGetDisbursementQueryKey(options),
    });
};
/**
 * Update a disbursement hold
 * Update a disbursement hold for a loan.
 */
export const lendingDisbursementsUpdateDisbursementHoldMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingDisbursementsUpdateDisbursementHold({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingDisbursementsCancelDisbursementHoldQueryKey = (options) => createQueryKey('lendingDisbursementsCancelDisbursementHold', options);
/**
 * Cancel a disbursement hold
 * Cancel a disbursement hold for a loan.
 */
export const lendingDisbursementsCancelDisbursementHoldOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingDisbursementsCancelDisbursementHold({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingDisbursementsCancelDisbursementHoldQueryKey(options),
    });
};
/**
 * Cancel a disbursement hold
 * Cancel a disbursement hold for a loan.
 */
export const lendingDisbursementsCancelDisbursementHoldMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingDisbursementsCancelDisbursementHold({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingDisbursementsClearDisbursementHoldQueryKey = (options) => createQueryKey('lendingDisbursementsClearDisbursementHold', options);
/**
 * Clear a disbursement hold
 * Clear a disbursement hold for a loan.
 */
export const lendingDisbursementsClearDisbursementHoldOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingDisbursementsClearDisbursementHold({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingDisbursementsClearDisbursementHoldQueryKey(options),
    });
};
/**
 * Clear a disbursement hold
 * Clear a disbursement hold for a loan.
 */
export const lendingDisbursementsClearDisbursementHoldMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingDisbursementsClearDisbursementHold({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingPaymentsListLoanPaymentsQueryKey = (options) => createQueryKey('lendingPaymentsListLoanPayments', options);
/**
 * List all payments
 * List all payments under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const lendingPaymentsListLoanPaymentsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingPaymentsListLoanPayments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingPaymentsListLoanPaymentsQueryKey(options),
    });
};
export const lendingPaymentsCreateLoanPaymentQueryKey = (options) => createQueryKey('lendingPaymentsCreateLoanPayment', options);
/**
 * Create a payment
 * Creates a payment for a loan. [Read more]({{lending.report}}).
 */
export const lendingPaymentsCreateLoanPaymentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingPaymentsCreateLoanPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingPaymentsCreateLoanPaymentQueryKey(options),
    });
};
/**
 * Create a payment
 * Creates a payment for a loan. [Read more]({{lending.report}}).
 */
export const lendingPaymentsCreateLoanPaymentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingPaymentsCreateLoanPayment({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingPaymentsGetLoanPaymentQueryKey = (options) => createQueryKey('lendingPaymentsGetLoanPayment', options);
/**
 * Get a payment
 * Retrieve a single loan payment by its ID.
 */
export const lendingPaymentsGetLoanPaymentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingPaymentsGetLoanPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingPaymentsGetLoanPaymentQueryKey(options),
    });
};
export const lendingPaymentsReturnLoanPaymentQueryKey = (options) => createQueryKey('lendingPaymentsReturnLoanPayment', options);
/**
 * Return a payment
 * Return a loan payment by its ID.
 */
export const lendingPaymentsReturnLoanPaymentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingPaymentsReturnLoanPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingPaymentsReturnLoanPaymentQueryKey(options),
    });
};
/**
 * Return a payment
 * Return a loan payment by its ID.
 */
export const lendingPaymentsReturnLoanPaymentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingPaymentsReturnLoanPayment({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingLoanListLoanProgramsQueryKey = (options) => createQueryKey('lendingLoanListLoanPrograms', options);
/**
 * List loan programs
 * List all loan programs for your platform. No query parameters are available - all loan programs for your platform will be returned.
 */
export const lendingLoanListLoanProgramsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingLoanListLoanPrograms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingLoanListLoanProgramsQueryKey(options),
    });
};
export const lendingLoanGetLoanProgramQueryKey = (options) => createQueryKey('lendingLoanGetLoanProgram', options);
/**
 * Get a loan program
 * Retrieve a single loan program by its ID.
 */
export const lendingLoanGetLoanProgramOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingLoanGetLoanProgram({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingLoanGetLoanProgramQueryKey(options),
    });
};
/**
 * Update loan program
 * It's unlikely that you will need to update a loan program. Please work with your Column team / Solution Engineer to update a loan program.
 */
export const lendingLoanUpdateLoanProgramMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await lendingLoanUpdateLoanProgram({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const lendingSaleListSalesQueryKey = (options) => createQueryKey('lendingSaleListSales', options);
/**
 * List all loan sales
 * List loan sales under your platform.
 */
export const lendingSaleListSalesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingSaleListSales({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingSaleListSalesQueryKey(options),
    });
};
export const lendingSaleGetSaleQueryKey = (options) => createQueryKey('lendingSaleGetSale', options);
/**
 * Get a loan sale
 * Retrieve a single loan sale by its ID.
 */
export const lendingSaleGetSaleOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingSaleGetSale({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingSaleGetSaleQueryKey(options),
    });
};
export const lendingSaleGetDailyLoansAvailableForSaleQueryKey = (options) => createQueryKey('lendingSaleGetDailyLoansAvailableForSale', options);
/**
 * Get loan sale summaries for loans available for sale
 * Get loan sale summaries for loans available for sale. Data returned by this API are updated daily after `loan_daily_summary` reports are generated. [Read more]({{lending.report}}).
 */
export const lendingSaleGetDailyLoansAvailableForSaleOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingSaleGetDailyLoansAvailableForSale({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingSaleGetDailyLoansAvailableForSaleQueryKey(options),
    });
};
export const lendingSaleGetDailySoldLoansQueryKey = (options) => createQueryKey('lendingSaleGetDailySoldLoans', options);
/**
 * Get loan sale summaries for loans already sold
 * Get loan sale summaries for loans already sold. Data returned by this API are updated daily after `loan_daily_summary` reports are generated. [Read more]({{lending.report}}).
 */
export const lendingSaleGetDailySoldLoansOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await lendingSaleGetDailySoldLoans({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: lendingSaleGetDailySoldLoansQueryKey(options),
    });
};
export const miscGetMarketRatesQueryKey = (options) => createQueryKey('miscGetMarketRates', options);
/**
 * List market rates
 * Retrieve all market rates published by the New York Fed on a given date.
 */
export const miscGetMarketRatesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await miscGetMarketRates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: miscGetMarketRatesQueryKey(options),
    });
};
export const reportingListSettlementReportsQueryKey = (options) => createQueryKey('reportingListSettlementReports', options);
/**
 * List all settlement reports
 * List all available settlement reports under the platform. Filtered results can be retrieved with extra parameters in the query.
 */
export const reportingListSettlementReportsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await reportingListSettlementReports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: reportingListSettlementReportsQueryKey(options),
    });
};
export const reportingScheduleSettlementReportQueryKey = (options) => createQueryKey('reportingScheduleSettlementReport', options);
/**
 * Schedule a settlement report
 */
export const reportingScheduleSettlementReportOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await reportingScheduleSettlementReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: reportingScheduleSettlementReportQueryKey(options),
    });
};
/**
 * Schedule a settlement report
 */
export const reportingScheduleSettlementReportMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await reportingScheduleSettlementReport({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const reportingGetSettlementReportQueryKey = (options) => createQueryKey('reportingGetSettlementReport', options);
/**
 * Get a settlement report by ID
 * Get a settlement report by its ID. Please refer to our [Reporting Guides]({{guides.reporting}}) for more details.
 */
export const reportingGetSettlementReportOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await reportingGetSettlementReport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: reportingGetSettlementReportQueryKey(options),
    });
};
export const bankAccountExportBankAccountActivitiesQueryKey = (options) => createQueryKey('bankAccountExportBankAccountActivities', options);
/**
 * Get a customized bank account statement
 * Generate a customized bank account statement for a specific bank account and date range. The response is a CSV file download.
 */
export const bankAccountExportBankAccountActivitiesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await bankAccountExportBankAccountActivities({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: bankAccountExportBankAccountActivitiesQueryKey(options),
    });
};
export const transferChecksDepositIssuedCheckQueryKey = (options) => createQueryKey('transferChecksDepositIssuedCheck', options);
/**
 * Deposit an issued check
 * Simulates the deposit of an issued check. This API is always enabled, and is not affected by the operating hours of the sandbox Fed Check21 system.
 */
export const transferChecksDepositIssuedCheckOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferChecksDepositIssuedCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferChecksDepositIssuedCheckQueryKey(options),
    });
};
/**
 * Deposit an issued check
 * Simulates the deposit of an issued check. This API is always enabled, and is not affected by the operating hours of the sandbox Fed Check21 system.
 */
export const transferChecksDepositIssuedCheckMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferChecksDepositIssuedCheck({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const interestsPayoutInterestQueryKey = (options) => createQueryKey('interestsPayoutInterest', options);
/**
 * Simulate an interest payout
 * Simulates an interest payout to the given interest bearing product.
 */
export const interestsPayoutInterestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await interestsPayoutInterest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: interestsPayoutInterestQueryKey(options),
    });
};
/**
 * Simulate an interest payout
 * Simulates an interest payout to the given interest bearing product.
 */
export const interestsPayoutInterestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await interestsPayoutInterest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsCreateCardProgramQueryKey = (options) => createQueryKey('cardsCreateCardProgram', options);
/**
 * Create sandbox card program
 * Creates a sandbox card program for issuing simulation workflows.
 */
export const cardsCreateCardProgramOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCreateCardProgram({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCreateCardProgramQueryKey(options),
    });
};
/**
 * Create sandbox card program
 * Creates a sandbox card program for issuing simulation workflows.
 */
export const cardsCreateCardProgramMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCreateCardProgram({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsCloseCardProgramQueryKey = (options) => createQueryKey('cardsCloseCardProgram', options);
/**
 * Close sandbox card program
 * Closes a sandbox card program for issuing simulation workflows.
 */
export const cardsCloseCardProgramOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsCloseCardProgram({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsCloseCardProgramQueryKey(options),
    });
};
/**
 * Close sandbox card program
 * Closes a sandbox card program for issuing simulation workflows.
 */
export const cardsCloseCardProgramMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsCloseCardProgram({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateCaptureQueryKey = (options) => createQueryKey('cardsSimulateCapture', options);
/**
 * Simulate capture
 * Simulate a capture that converts an authorization hold into a settled transaction. The original transaction must have
 * started as an authorization and have an active hold.
 *
 * Set `is_partial_capture` to `true` to keep the remaining hold active for future captures, as with split shipments; the
 * amount must not exceed the remaining authorized amount. Otherwise the capture is final and releases the remaining hold,
 * and the amount may exceed the authorized amount, as with tips or hotel incidentals.
 */
export const cardsSimulateCaptureOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateCapture({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateCaptureQueryKey(options),
    });
};
/**
 * Simulate capture
 * Simulate a capture that converts an authorization hold into a settled transaction. The original transaction must have
 * started as an authorization and have an active hold.
 *
 * Set `is_partial_capture` to `true` to keep the remaining hold active for future captures, as with split shipments; the
 * amount must not exceed the remaining authorized amount. Otherwise the capture is final and releases the remaining hold,
 * and the amount may exceed the authorized amount, as with tips or hotel incidentals.
 */
export const cardsSimulateCaptureMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateCapture({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateIncrementalAuthorizationQueryKey = (options) => createQueryKey('cardsSimulateIncrementalAuthorization', options);
/**
 * Simulate incremental authorization
 * Simulate an incremental authorization that adds to an existing authorization hold, such as a hotel stay extension.
 * Currency codes are preserved from the initial authorization.
 *
 * The original transaction must have started as an authorization, not a full financial transaction, and must not have
 * captured funds. Column sends a real-time authorization decision request for the increment to your endpoint subscribed
 * to `decision.issuing.card_transaction`, and declines if none is configured.
 */
export const cardsSimulateIncrementalAuthorizationOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateIncrementalAuthorization({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateIncrementalAuthorizationQueryKey(options),
    });
};
/**
 * Simulate incremental authorization
 * Simulate an incremental authorization that adds to an existing authorization hold, such as a hotel stay extension.
 * Currency codes are preserved from the initial authorization.
 *
 * The original transaction must have started as an authorization, not a full financial transaction, and must not have
 * captured funds. Column sends a real-time authorization decision request for the increment to your endpoint subscribed
 * to `decision.issuing.card_transaction`, and declines if none is configured.
 */
export const cardsSimulateIncrementalAuthorizationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateIncrementalAuthorization({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateRefundQueryKey = (options) => createQueryKey('cardsSimulateRefund', options);
/**
 * Simulate refund
 * Simulate a merchandise return against a settled card transaction. Each call creates a new refund transaction linked to
 * the purchase by `original_card_transaction_id`, and the total refunded must not exceed the settled amount.
 */
export const cardsSimulateRefundOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateRefund({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateRefundQueryKey(options),
    });
};
/**
 * Simulate refund
 * Simulate a merchandise return against a settled card transaction. Each call creates a new refund transaction linked to
 * the purchase by `original_card_transaction_id`, and the total refunded must not exceed the settled amount.
 */
export const cardsSimulateRefundMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateRefund({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateReversalQueryKey = (options) => createQueryKey('cardsSimulateReversal', options);
/**
 * Simulate reversal
 * Simulate an acquirer reversing the message that opened a card transaction, as with a voided sale or a
 * terminal that never got its authorization response. The transaction must have started as an authorization
 * or a full financial transaction.
 *
 * Omit `cardholder_amount` to reverse in full: an authorization releases whatever hold the series still
 * carries, including incremental authorizations, and a full financial transaction reverses its settled
 * amount. Set `cardholder_amount` to release part of an authorization hold and leave the rest active, as
 * with a partially filled order; partial reversals don't apply to full financial transactions.
 *
 * Reversals act on the outstanding authorization hold, so a transaction that has already been captured has
 * nothing left to reverse — refund it instead.
 */
export const cardsSimulateReversalOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateReversal({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateReversalQueryKey(options),
    });
};
/**
 * Simulate reversal
 * Simulate an acquirer reversing the message that opened a card transaction, as with a voided sale or a
 * terminal that never got its authorization response. The transaction must have started as an authorization
 * or a full financial transaction.
 *
 * Omit `cardholder_amount` to reverse in full: an authorization releases whatever hold the series still
 * carries, including incremental authorizations, and a full financial transaction reverses its settled
 * amount. Set `cardholder_amount` to release part of an authorization hold and leave the rest active, as
 * with a partially filled order; partial reversals don't apply to full financial transactions.
 *
 * Reversals act on the outstanding authorization hold, so a transaction that has already been captured has
 * nothing left to reverse — refund it instead.
 */
export const cardsSimulateReversalMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateReversal({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateAddCardToWalletQueryKey = (options) => createQueryKey('cardsSimulateAddCardToWallet', options);
/**
 * Simulate add card to wallet
 * Simulate adding a `visa_sandbox` card to Apple Pay, Google Pay, or Samsung Pay from your app. Takes the same request
 * and returns the same response shape as add card to wallet, with placeholder payloads that a real wallet SDK cannot use.
 *
 * The card goes through the same eligibility checks, then Column simulates the wallet's provisioning request: it creates
 * a card token for the requested wallet, sends your `decision.issuing.card_token` endpoint a real-time decision request,
 * and fires the `issuing.card_token.*` webhooks.
 *
 */
export const cardsSimulateAddCardToWalletOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateAddCardToWallet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateAddCardToWalletQueryKey(options),
    });
};
/**
 * Simulate add card to wallet
 * Simulate adding a `visa_sandbox` card to Apple Pay, Google Pay, or Samsung Pay from your app. Takes the same request
 * and returns the same response shape as add card to wallet, with placeholder payloads that a real wallet SDK cannot use.
 *
 * The card goes through the same eligibility checks, then Column simulates the wallet's provisioning request: it creates
 * a card token for the requested wallet, sends your `decision.issuing.card_token` endpoint a real-time decision request,
 * and fires the `issuing.card_token.*` webhooks.
 *
 */
export const cardsSimulateAddCardToWalletMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateAddCardToWallet({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateCardAuthorizationQueryKey = (options) => createQueryKey('cardsSimulateCardAuthorization', options);
/**
 * Simulate card authorization
 * Simulate a card authorization for a sandbox card. The cardholder is always billed in `USD`; when `merchant_currency`
 * is not `USD`, provide `cardholder_fx_rate`.
 *
 * When neither `realtime_decision` nor `network_standin` is set, Column sends a real-time authorization decision request
 * to your endpoint subscribed to `decision.issuing.card_transaction`, and declines if none is configured. Set
 * `realtime_decision` to supply the decision without calling your endpoint, or `network_standin` to simulate the card
 * network deciding on your behalf. To attach 3DS authentication details, pass an `authenticated` `three_ds_attempt_id`
 * for the same card.
 *
 * To test PIN outcomes on a physical card, pass the PIN the cardholder enters in `cardholder_input.pin`. Column checks
 * it with its real PIN verification and lockout, so a wrong PIN declines with `pin_invalid`, a card with no PIN with
 * `pin_not_set`, and a card whose PIN is blocked after 3 wrong PINs with `pin_blocked`.
 *
 * To test card-present and card-not-present decisioning, set `entry_mode` to `swipe`, `keyed` or `ecommerce`. By
 * default a physical card is swiped and a virtual card is used at an online checkout. Virtual cards only support
 * `ecommerce`, and a PIN can't be entered with `ecommerce`.
 *
 * To test CVV2 outcomes, pass the CVV2 the cardholder enters in `cardholder_input.cvv2` with `entry_mode` `keyed` or
 * `ecommerce` (a virtual card's default). Column checks it with its real CVV2 verification, so a wrong CVV2 declines
 * with `invalid_cvv2`. When omitted, the card's real CVV2 is sent. A swiped card carries no CVV2.
 *
 * To test expiration date outcomes, pass the date the cardholder presents in `cardholder_input.expiration_date`.
 * Column compares it with the card's expiration, so a date that doesn't match declines with `invalid_expiration`.
 * Without it, the simulated transaction carries no expiration date and Column skips the check.
 *
 * To test address verification (AVS), pass the billing address the cardholder enters in
 * `cardholder_input.billing_address`. Column compares it with the cardholder entity's address and reports each
 * field as `verified` or `invalid` in the transaction's `cardholder_verification_details`. AVS doesn't decline
 * the authorization by itself.
 */
export const cardsSimulateCardAuthorizationOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateCardAuthorization({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateCardAuthorizationQueryKey(options),
    });
};
/**
 * Simulate card authorization
 * Simulate a card authorization for a sandbox card. The cardholder is always billed in `USD`; when `merchant_currency`
 * is not `USD`, provide `cardholder_fx_rate`.
 *
 * When neither `realtime_decision` nor `network_standin` is set, Column sends a real-time authorization decision request
 * to your endpoint subscribed to `decision.issuing.card_transaction`, and declines if none is configured. Set
 * `realtime_decision` to supply the decision without calling your endpoint, or `network_standin` to simulate the card
 * network deciding on your behalf. To attach 3DS authentication details, pass an `authenticated` `three_ds_attempt_id`
 * for the same card.
 *
 * To test PIN outcomes on a physical card, pass the PIN the cardholder enters in `cardholder_input.pin`. Column checks
 * it with its real PIN verification and lockout, so a wrong PIN declines with `pin_invalid`, a card with no PIN with
 * `pin_not_set`, and a card whose PIN is blocked after 3 wrong PINs with `pin_blocked`.
 *
 * To test card-present and card-not-present decisioning, set `entry_mode` to `swipe`, `keyed` or `ecommerce`. By
 * default a physical card is swiped and a virtual card is used at an online checkout. Virtual cards only support
 * `ecommerce`, and a PIN can't be entered with `ecommerce`.
 *
 * To test CVV2 outcomes, pass the CVV2 the cardholder enters in `cardholder_input.cvv2` with `entry_mode` `keyed` or
 * `ecommerce` (a virtual card's default). Column checks it with its real CVV2 verification, so a wrong CVV2 declines
 * with `invalid_cvv2`. When omitted, the card's real CVV2 is sent. A swiped card carries no CVV2.
 *
 * To test expiration date outcomes, pass the date the cardholder presents in `cardholder_input.expiration_date`.
 * Column compares it with the card's expiration, so a date that doesn't match declines with `invalid_expiration`.
 * Without it, the simulated transaction carries no expiration date and Column skips the check.
 *
 * To test address verification (AVS), pass the billing address the cardholder enters in
 * `cardholder_input.billing_address`. Column compares it with the cardholder entity's address and reports each
 * field as `verified` or `invalid` in the transaction's `cardholder_verification_details`. AVS doesn't decline
 * the authorization by itself.
 */
export const cardsSimulateCardAuthorizationMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateCardAuthorization({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateCardFinancialQueryKey = (options) => createQueryKey('cardsSimulateCardFinancial', options);
/**
 * Simulate full financial transaction
 * Simulate a full financial transaction for a sandbox card. Full financial transactions capture funds immediately without
 * a prior authorization hold, as with transit taps, low-value purchases, and offline transactions. The cardholder is
 * always billed in `USD`; when `merchant_currency` is not `USD`, provide `cardholder_fx_rate`.
 *
 * When `realtime_decision` is not set, Column sends a real-time authorization decision request to your endpoint
 * subscribed to `decision.issuing.card_transaction`, and declines if none is configured. Set `realtime_decision` to
 * supply the decision without calling your endpoint.
 *
 * To test PIN outcomes on a PIN debit purchase with a physical card, pass the PIN the cardholder enters in
 * `cardholder_input.pin`. Column checks it with its real PIN verification and lockout, so a wrong PIN declines with
 * `pin_invalid`, a card with no PIN with `pin_not_set`, and a card whose PIN is blocked after 3 wrong PINs with
 * `pin_blocked`.
 *
 * On a virtual card, `cardholder_input.cvv2` sets the CVV2 the cardholder enters, and a wrong CVV2 declines with
 * `invalid_cvv2`.
 *
 * `cardholder_input.expiration_date` sets the expiration date the cardholder presents, and a date that doesn't match
 * the card's declines with `invalid_expiration`.
 *
 * To test address verification (AVS), pass the billing address the cardholder enters in
 * `cardholder_input.billing_address`, as on an authorization. AVS doesn't decline the transaction by itself.
 */
export const cardsSimulateCardFinancialOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateCardFinancial({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateCardFinancialQueryKey(options),
    });
};
/**
 * Simulate full financial transaction
 * Simulate a full financial transaction for a sandbox card. Full financial transactions capture funds immediately without
 * a prior authorization hold, as with transit taps, low-value purchases, and offline transactions. The cardholder is
 * always billed in `USD`; when `merchant_currency` is not `USD`, provide `cardholder_fx_rate`.
 *
 * When `realtime_decision` is not set, Column sends a real-time authorization decision request to your endpoint
 * subscribed to `decision.issuing.card_transaction`, and declines if none is configured. Set `realtime_decision` to
 * supply the decision without calling your endpoint.
 *
 * To test PIN outcomes on a PIN debit purchase with a physical card, pass the PIN the cardholder enters in
 * `cardholder_input.pin`. Column checks it with its real PIN verification and lockout, so a wrong PIN declines with
 * `pin_invalid`, a card with no PIN with `pin_not_set`, and a card whose PIN is blocked after 3 wrong PINs with
 * `pin_blocked`.
 *
 * On a virtual card, `cardholder_input.cvv2` sets the CVV2 the cardholder enters, and a wrong CVV2 declines with
 * `invalid_cvv2`.
 *
 * `cardholder_input.expiration_date` sets the expiration date the cardholder presents, and a date that doesn't match
 * the card's declines with `invalid_expiration`.
 *
 * To test address verification (AVS), pass the billing address the cardholder enters in
 * `cardholder_input.billing_address`, as on an authorization. AVS doesn't decline the transaction by itself.
 */
export const cardsSimulateCardFinancialMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateCardFinancial({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateRevealCardDetailsQueryKey = (options) => createQueryKey('cardsSimulateRevealCardDetails', options);
/**
 * Reveal sandbox card details
 * Reveal a sandbox card's full details without going through VGS. Authenticate with a card reveal token instead of your API key, sent as `Authorization: Bearer <card_reveal_token_id>`. Create one with the create card reveal token endpoint; each token is single use, expires, and only works for the card it was created for.
 */
export const cardsSimulateRevealCardDetailsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateRevealCardDetails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateRevealCardDetailsQueryKey(options),
    });
};
export const cardsSimulateThreeDsChallengeQueryKey = (options) => createQueryKey('cardsSimulateThreeDsChallenge', options);
/**
 * Simulate 3DS authentication
 * Simulate a 3DS authentication attempt for a sandbox card and return the resulting 3DS attempt.
 *
 * Set `realtime_decision` to supply the authentication decision without calling your endpoint. When it is omitted, Column
 * sends a 3DS authentication decision request to your endpoint subscribed to `decision.issuing.card_authentication`; if
 * no endpoint is subscribed, the simulator creates an OTP challenge.
 *
 * - `frictionless_approve` authenticates the attempt and fires `issuing.3ds.authentication_completed`.
 * - `challenge` starts an OTP challenge and fires `issuing.3ds.otp_generated`. Finish it with the complete 3DS challenge
 * endpoint.
 * - `decline_authentication` rejects the attempt and fires `issuing.3ds.authentication_completed`.
 */
export const cardsSimulateThreeDsChallengeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateThreeDsChallenge({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateThreeDsChallengeQueryKey(options),
    });
};
/**
 * Simulate 3DS authentication
 * Simulate a 3DS authentication attempt for a sandbox card and return the resulting 3DS attempt.
 *
 * Set `realtime_decision` to supply the authentication decision without calling your endpoint. When it is omitted, Column
 * sends a 3DS authentication decision request to your endpoint subscribed to `decision.issuing.card_authentication`; if
 * no endpoint is subscribed, the simulator creates an OTP challenge.
 *
 * - `frictionless_approve` authenticates the attempt and fires `issuing.3ds.authentication_completed`.
 * - `challenge` starts an OTP challenge and fires `issuing.3ds.otp_generated`. Finish it with the complete 3DS challenge
 * endpoint.
 * - `decline_authentication` rejects the attempt and fires `issuing.3ds.authentication_completed`.
 */
export const cardsSimulateThreeDsChallengeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateThreeDsChallenge({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateApproveProvisioningQueryKey = (options) => createQueryKey('cardsSimulateApproveProvisioning', options);
/**
 * Simulate approve provisioning
 * Simulate a digital wallet's provisioning request for a card token in `pending_activation` status, as returned by the
 * token eligibility check. Set `wallet_type` to `apple_pay`, `google_pay`, or `samsung_pay` to attribute the token to a
 * wallet.
 *
 * Set `action_code` to `approve`, `decline`, or `step_up` to force the decision without calling your
 * `decision.issuing.card_token` endpoint. When it is omitted, the decision flows through Column's real provisioning
 * decisioning, including that endpoint. A `step_up` decision also simulates the step-up methods and send passcode
 * callbacks when the cardholder has contact info on file, leaving the token ready for step-up completion.
 */
export const cardsSimulateApproveProvisioningOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateApproveProvisioning({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateApproveProvisioningQueryKey(options),
    });
};
/**
 * Simulate approve provisioning
 * Simulate a digital wallet's provisioning request for a card token in `pending_activation` status, as returned by the
 * token eligibility check. Set `wallet_type` to `apple_pay`, `google_pay`, or `samsung_pay` to attribute the token to a
 * wallet.
 *
 * Set `action_code` to `approve`, `decline`, or `step_up` to force the decision without calling your
 * `decision.issuing.card_token` endpoint. When it is omitted, the decision flows through Column's real provisioning
 * decisioning, including that endpoint. A `step_up` decision also simulates the step-up methods and send passcode
 * callbacks when the cardholder has contact info on file, leaving the token ready for step-up completion.
 */
export const cardsSimulateApproveProvisioningMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateApproveProvisioning({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateDeactivateQueryKey = (options) => createQueryKey('cardsSimulateDeactivate', options);
/**
 * Simulate token deactivate
 * Simulate the card network deactivating a card token on a `visa_sandbox` card. The token moves to `deactivated` and `issuing.card_token.deactivated` fires, exactly as for a production network notification. Deactivating a token that is already `deactivated` returns it unchanged without firing an event.
 */
export const cardsSimulateDeactivateOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateDeactivate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateDeactivateQueryKey(options),
    });
};
/**
 * Simulate token deactivate
 * Simulate the card network deactivating a card token on a `visa_sandbox` card. The token moves to `deactivated` and `issuing.card_token.deactivated` fires, exactly as for a production network notification. Deactivating a token that is already `deactivated` returns it unchanged without firing an event.
 */
export const cardsSimulateDeactivateMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateDeactivate({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateDeviceBindingQueryKey = (options) => createQueryKey('cardsSimulateDeviceBinding', options);
/**
 * Simulate device binding
 * Simulate a Visa device binding for a card token on a `visa_sandbox` card. Column records the binding and its decision
 * on the token and returns the updated card token.
 *
 * Set `decision_override` to `approve`, `decline`, or `step_up` to force the outcome without calling your endpoint. When
 * it is omitted, the binding flows through Column's real decisioning.
 */
export const cardsSimulateDeviceBindingOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateDeviceBinding({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateDeviceBindingQueryKey(options),
    });
};
/**
 * Simulate device binding
 * Simulate a Visa device binding for a card token on a `visa_sandbox` card. Column records the binding and its decision
 * on the token and returns the updated card token.
 *
 * Set `decision_override` to `approve`, `decline`, or `step_up` to force the outcome without calling your endpoint. When
 * it is omitted, the binding flows through Column's real decisioning.
 */
export const cardsSimulateDeviceBindingMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateDeviceBinding({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateResumeQueryKey = (options) => createQueryKey('cardsSimulateResume', options);
/**
 * Simulate token resume
 * Simulate the card network resuming a paused card token on a `visa_sandbox` card. The token moves back to `active` and `issuing.card_token.activated` fires, exactly as for a production network notification.
 */
export const cardsSimulateResumeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateResume({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateResumeQueryKey(options),
    });
};
/**
 * Simulate token resume
 * Simulate the card network resuming a paused card token on a `visa_sandbox` card. The token moves back to `active` and `issuing.card_token.activated` fires, exactly as for a production network notification.
 */
export const cardsSimulateResumeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateResume({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateStepUpCompleteQueryKey = (options) => createQueryKey('cardsSimulateStepUpComplete', options);
/**
 * Simulate step-up complete
 * Simulate the final step of Visa's step-up flow for a sandbox card token in `pending_authentication` status. An
 * `outcome` of `success` activates the token and fires `issuing.card_token.activated`; `failure` moves it to
 * `activation_denied` and fires `issuing.card_token.activation_denied`. Tokens in any other status return an error.
 */
export const cardsSimulateStepUpCompleteOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateStepUpComplete({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateStepUpCompleteQueryKey(options),
    });
};
/**
 * Simulate step-up complete
 * Simulate the final step of Visa's step-up flow for a sandbox card token in `pending_authentication` status. An
 * `outcome` of `success` activates the token and fires `issuing.card_token.activated`; `failure` moves it to
 * `activation_denied` and fires `issuing.card_token.activation_denied`. Tokens in any other status return an error.
 */
export const cardsSimulateStepUpCompleteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateStepUpComplete({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateStepUpMethodsQueryKey = (options) => createQueryKey('cardsSimulateStepUpMethods', options);
/**
 * Simulate step-up retrieve methods
 * Simulate Visa's retrieve step-up methods callback for a sandbox card token. Returns the SMS and email methods available
 * from the cardholder's contact info, or an empty list when none is on file, and records them on the token so a later
 * send passcode call can resolve the selected method.
 */
export const cardsSimulateStepUpMethodsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateStepUpMethods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateStepUpMethodsQueryKey(options),
    });
};
/**
 * Simulate step-up retrieve methods
 * Simulate Visa's retrieve step-up methods callback for a sandbox card token. Returns the SMS and email methods available
 * from the cardholder's contact info, or an empty list when none is on file, and records them on the token so a later
 * send passcode call can resolve the selected method.
 */
export const cardsSimulateStepUpMethodsMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateStepUpMethods({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateSendPasscodeQueryKey = (options) => createQueryKey('cardsSimulateSendPasscode', options);
/**
 * Simulate step-up send passcode
 * Simulate Visa's send passcode callback for a sandbox card token, after retrieving step-up methods. Column fires the
 * `issuing.card_token.send_passcode` webhook with a simulated one-time passcode and moves the token to
 * `pending_authentication`.
 *
 * Pass one of the returned method identifiers as `otp_method_identifier` to choose where the passcode goes. When it is
 * omitted, an available method is selected automatically.
 */
export const cardsSimulateSendPasscodeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateSendPasscode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateSendPasscodeQueryKey(options),
    });
};
/**
 * Simulate step-up send passcode
 * Simulate Visa's send passcode callback for a sandbox card token, after retrieving step-up methods. Column fires the
 * `issuing.card_token.send_passcode` webhook with a simulated one-time passcode and moves the token to
 * `pending_authentication`.
 *
 * Pass one of the returned method identifiers as `otp_method_identifier` to choose where the passcode goes. When it is
 * omitted, an available method is selected automatically.
 */
export const cardsSimulateSendPasscodeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateSendPasscode({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateSuspendQueryKey = (options) => createQueryKey('cardsSimulateSuspend', options);
/**
 * Simulate token suspend
 * Simulate the card network suspending a card token on a `visa_sandbox` card. The token moves to `paused` and `issuing.card_token.paused` fires, exactly as for a production network notification.
 */
export const cardsSimulateSuspendOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateSuspend({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateSuspendQueryKey(options),
    });
};
/**
 * Simulate token suspend
 * Simulate the card network suspending a card token on a `visa_sandbox` card. The token moves to `paused` and `issuing.card_token.paused` fires, exactly as for a production network notification.
 */
export const cardsSimulateSuspendMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateSuspend({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateCheckEligibilityQueryKey = (options) => createQueryKey('cardsSimulateCheckEligibility', options);
/**
 * Simulate token eligibility check
 * Simulate a digital wallet checking whether a `visa_sandbox` card can be tokenized, the first step of token
 * provisioning. An eligible card returns a new card token in `pending_activation` status; an ineligible card returns an
 * error with the reason.
 *
 * Continue provisioning by simulating approve provisioning on the returned card token.
 */
export const cardsSimulateCheckEligibilityOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateCheckEligibility({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateCheckEligibilityQueryKey(options),
    });
};
/**
 * Simulate token eligibility check
 * Simulate a digital wallet checking whether a `visa_sandbox` card can be tokenized, the first step of token
 * provisioning. An eligible card returns a new card token in `pending_activation` status; an ineligible card returns an
 * error with the reason.
 *
 * Continue provisioning by simulating approve provisioning on the returned card token.
 */
export const cardsSimulateCheckEligibilityMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateCheckEligibility({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const cardsSimulateCompleteThreeDsChallengeQueryKey = (options) => createQueryKey('cardsSimulateCompleteThreeDsChallenge', options);
/**
 * Complete simulated 3DS challenge
 * Complete the OTP challenge on a simulated 3DS attempt. The attempt must have an open challenge, created by simulating a
 * 3DS authentication that resolves to `challenge`.
 *
 * An `outcome` of `successful` authenticates the attempt, which you can then pass as `three_ds_attempt_id` when
 * simulating a card authorization. `failed` rejects the attempt. Both outcomes fire `issuing.3ds.authentication_completed`.
 */
export const cardsSimulateCompleteThreeDsChallengeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await cardsSimulateCompleteThreeDsChallenge({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: cardsSimulateCompleteThreeDsChallengeQueryKey(options),
    });
};
/**
 * Complete simulated 3DS challenge
 * Complete the OTP challenge on a simulated 3DS attempt. The attempt must have an open challenge, created by simulating a
 * 3DS authentication that resolves to `challenge`.
 *
 * An `outcome` of `successful` authenticates the attempt, which you can then pass as `three_ds_attempt_id` when
 * simulating a card authorization. `failed` rejects the attempt. Both outcomes fire `issuing.3ds.authentication_completed`.
 */
export const cardsSimulateCompleteThreeDsChallengeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await cardsSimulateCompleteThreeDsChallenge({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchReceiveAchCreditTransferQueryKey = (options) => createQueryKey('transferAchReceiveAchCreditTransfer', options);
/**
 * Receive an ACH Credit
 * Simulates an incoming ACH Credit transfer to an account for the amount specified. To more accurately represent a production environment, we process incoming ACH transfers every hour. You will not see the effects of an incoming ACH transfer until the ACH is processed.
 */
export const transferAchReceiveAchCreditTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchReceiveAchCreditTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchReceiveAchCreditTransferQueryKey(options),
    });
};
/**
 * Receive an ACH Credit
 * Simulates an incoming ACH Credit transfer to an account for the amount specified. To more accurately represent a production environment, we process incoming ACH transfers every hour. You will not see the effects of an incoming ACH transfer until the ACH is processed.
 */
export const transferAchReceiveAchCreditTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchReceiveAchCreditTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchReceiveAchDebitTransferQueryKey = (options) => createQueryKey('transferAchReceiveAchDebitTransfer', options);
/**
 * Receive an ACH Debit
 * Simulates an incoming ACH Debit transfer from an account for the amount specified. To more accurately represent a production environment, we process incoming ACH transfers every hour. You will not see the effects of an incoming ACH transfer until the ACH is processed.
 */
export const transferAchReceiveAchDebitTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchReceiveAchDebitTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchReceiveAchDebitTransferQueryKey(options),
    });
};
/**
 * Receive an ACH Debit
 * Simulates an incoming ACH Debit transfer from an account for the amount specified. To more accurately represent a production environment, we process incoming ACH transfers every hour. You will not see the effects of an incoming ACH transfer until the ACH is processed.
 */
export const transferAchReceiveAchDebitTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchReceiveAchDebitTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftReceiveCorrespondentSwiftQueryKey = (options) => createQueryKey('transferSwiftReceiveCorrespondentSwift', options);
/**
 * Receive a correspondent SWIFT message
 * Simulates receiving an incoming correspondent SWIFT pacs.008 message. Accepts raw pacs.008 XML, auto-configures the correspondent platform infrastructure, and queues the message for async processing through the correspondent banking pipeline.
 */
export const transferSwiftReceiveCorrespondentSwiftOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftReceiveCorrespondentSwift({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftReceiveCorrespondentSwiftQueryKey(options),
    });
};
/**
 * Receive a correspondent SWIFT message
 * Simulates receiving an incoming correspondent SWIFT pacs.008 message. Accepts raw pacs.008 XML, auto-configures the correspondent platform infrastructure, and queues the message for async processing through the correspondent banking pipeline.
 */
export const transferSwiftReceiveCorrespondentSwiftMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftReceiveCorrespondentSwift({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireReceiveInternationalWireQueryKey = (options) => createQueryKey('transferWireReceiveInternationalWire', options);
/**
 * Receive an international wire
 * Simulates an incoming international wire transfer to an account for the amount specified.
 */
export const transferWireReceiveInternationalWireOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireReceiveInternationalWire({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireReceiveInternationalWireQueryKey(options),
    });
};
/**
 * Receive an international wire
 * Simulates an incoming international wire transfer to an account for the amount specified.
 */
export const transferWireReceiveInternationalWireMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireReceiveInternationalWire({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferLocalReceiveLocalTransferQueryKey = (options) => createQueryKey('transferLocalReceiveLocalTransfer', options);
/**
 * Receive a local transfer
 * Simulates an incoming local transfer to an account number for the amount specified. The account must be denominated in a non-USD currency with an active virtual account number, and the currency code must match the account's currency.
 */
export const transferLocalReceiveLocalTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferLocalReceiveLocalTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferLocalReceiveLocalTransferQueryKey(options),
    });
};
/**
 * Receive a local transfer
 * Simulates an incoming local transfer to an account number for the amount specified. The account must be denominated in a non-USD currency with an active virtual account number, and the currency code must match the account's currency.
 */
export const transferLocalReceiveLocalTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferLocalReceiveLocalTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftReceiveSwiftAccountReportRequestQueryKey = (options) => createQueryKey('transferSwiftReceiveSwiftAccountReportRequest', options);
/**
 * Receive a SWIFT account report request
 * Simulates a counterparty bank sending Column a camt.060 account reporting request for one of your bank accounts. Column answers with a balance-only camt.052 when the requesting BIC holds an active statement subscription for the account, and ignores the request otherwise.
 */
export const transferSwiftReceiveSwiftAccountReportRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftReceiveSwiftAccountReportRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftReceiveSwiftAccountReportRequestQueryKey(options),
    });
};
/**
 * Receive a SWIFT account report request
 * Simulates a counterparty bank sending Column a camt.060 account reporting request for one of your bank accounts. Column answers with a balance-only camt.052 when the requesting BIC holds an active statement subscription for the account, and ignores the request otherwise.
 */
export const transferSwiftReceiveSwiftAccountReportRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftReceiveSwiftAccountReportRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireReceiveWireTransferQueryKey = (options) => createQueryKey('transferWireReceiveWireTransfer', options);
/**
 * Receive a wire transfer
 * Simulates an incoming wire transfer to an account for the amount specified. We recommend using this API to set a balance on your account in the sandbox environment. This API is always enabled, and is not affected by the operating hours of the sandbox Fedwire system.
 */
export const transferWireReceiveWireTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireReceiveWireTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireReceiveWireTransferQueryKey(options),
    });
};
/**
 * Receive a wire transfer
 * Simulates an incoming wire transfer to an account for the amount specified. We recommend using this API to set a balance on your account in the sandbox environment. This API is always enabled, and is not affected by the operating hours of the sandbox Fedwire system.
 */
export const transferWireReceiveWireTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireReceiveWireTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireReceiveWireDrawdownRequestQueryKey = (options) => createQueryKey('transferWireReceiveWireDrawdownRequest', options);
/**
 * Receive a wire drawdown request
 * Simulates an incoming wire drawdown request into the specified account number ID.
 */
export const transferWireReceiveWireDrawdownRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireReceiveWireDrawdownRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireReceiveWireDrawdownRequestQueryKey(options),
    });
};
/**
 * Receive a wire drawdown request
 * Simulates an incoming wire drawdown request into the specified account number ID.
 */
export const transferWireReceiveWireDrawdownRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireReceiveWireDrawdownRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireReceiveWireReturnRequestQueryKey = (options) => createQueryKey('transferWireReceiveWireReturnRequest', options);
/**
 * Receive a wire return request
 * Simulates an incoming wire return request for a simulated incoming wire transfer.
 */
export const transferWireReceiveWireReturnRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireReceiveWireReturnRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireReceiveWireReturnRequestQueryKey(options),
    });
};
/**
 * Receive a wire return request
 * Simulates an incoming wire return request for a simulated incoming wire transfer.
 */
export const transferWireReceiveWireReturnRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireReceiveWireReturnRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const taxFormsCreateTaxFormQueryKey = (options) => createQueryKey('taxFormsCreateTaxForm', options);
/**
 * Create a tax form
 * Simulates the creation of a tax form for an entity. This allows you to test the tax form workflow including filing statuses, mailing, and webhook events. The normal `7` calendar days grace period for filing will be ignored in simulations.
 */
export const taxFormsCreateTaxFormOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await taxFormsCreateTaxForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: taxFormsCreateTaxFormQueryKey(options),
    });
};
/**
 * Create a tax form
 * Simulates the creation of a tax form for an entity. This allows you to test the tax form workflow including filing statuses, mailing, and webhook events. The normal `7` calendar days grace period for filing will be ignored in simulations.
 */
export const taxFormsCreateTaxFormMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await taxFormsCreateTaxForm({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchSettleAchTransferQueryKey = (options) => createQueryKey('transferAchSettleAchTransfer', options);
/**
 * Settle ACH transfer
 * Forces the settlement of an outgoing ACH transfer, regardless of the operating hours of the Sandbox Fed.
 */
export const transferAchSettleAchTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchSettleAchTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchSettleAchTransferQueryKey(options),
    });
};
/**
 * Settle ACH transfer
 * Forces the settlement of an outgoing ACH transfer, regardless of the operating hours of the Sandbox Fed.
 */
export const transferAchSettleAchTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchSettleAchTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferChecksSettleCheckTransferQueryKey = (options) => createQueryKey('transferChecksSettleCheckTransfer', options);
/**
 * Settle check deposit
 * Forces the settlement of a deposited check. After a check is deposited in sandbox, it is going to move from a `pending_deposit` state to a `deposited` state within an hour to simulate check forwarding to the Fed. This endpoint allows you to force settlement after the check is transitioned to a `deposited` state. This will transition the transfer to `settled` and make funds available immediately.
 */
export const transferChecksSettleCheckTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferChecksSettleCheckTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferChecksSettleCheckTransferQueryKey(options),
    });
};
/**
 * Settle check deposit
 * Forces the settlement of a deposited check. After a check is deposited in sandbox, it is going to move from a `pending_deposit` state to a `deposited` state within an hour to simulate check forwarding to the Fed. This endpoint allows you to force settlement after the check is transitioned to a `deposited` state. This will transition the transfer to `settled` and make funds available immediately.
 */
export const transferChecksSettleCheckTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferChecksSettleCheckTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeReceiveCreditQueryKey = (options) => createQueryKey('transferRealtimeReceiveCredit', options);
/**
 * Receive a realtime transfer
 * Simulates an incoming realtime transfer to an account for the amount specified.
 */
export const transferRealtimeReceiveCreditOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeReceiveCredit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeReceiveCreditQueryKey(options),
    });
};
/**
 * Receive a realtime transfer
 * Simulates an incoming realtime transfer to an account for the amount specified.
 */
export const transferRealtimeReceiveCreditMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeReceiveCredit({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeReceiveRfpQueryKey = (options) => createQueryKey('transferRealtimeReceiveRfp', options);
/**
 * Receive a realtime RFP (Request for Payment)
 * Simulates an incoming Realtime RFP to an account for the amount specified.
 */
export const transferRealtimeReceiveRfpOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeReceiveRfp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeReceiveRfpQueryKey(options),
    });
};
/**
 * Receive a realtime RFP (Request for Payment)
 * Simulates an incoming Realtime RFP to an account for the amount specified.
 */
export const transferRealtimeReceiveRfpMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeReceiveRfp({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireSettleWireTransferQueryKey = (options) => createQueryKey('transferWireSettleWireTransfer', options);
/**
 * Settle wire transfer
 * Forces the submission and settlement of an outgoing Wire transfer, regardless of the operating hours of the Sandbox Fed. The wire message should move from `PENDING_SUBMISSION` to `COMPLETED` after this API call.
 */
export const transferWireSettleWireTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireSettleWireTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireSettleWireTransferQueryKey(options),
    });
};
/**
 * Settle wire transfer
 * Forces the submission and settlement of an outgoing Wire transfer, regardless of the operating hours of the Sandbox Fed. The wire message should move from `PENDING_SUBMISSION` to `COMPLETED` after this API call.
 */
export const transferWireSettleWireTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireSettleWireTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const taxFormListTaxFormsQueryKey = (options) => createQueryKey('taxFormListTaxForms', options);
/**
 * List all tax forms
 * List all tax forms with optional filtering and pagination.
 */
export const taxFormListTaxFormsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await taxFormListTaxForms({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: taxFormListTaxFormsQueryKey(options),
    });
};
export const taxFormGetTaxFormQueryKey = (options) => createQueryKey('taxFormGetTaxForm', options);
/**
 * Get a tax form
 * Retrieve a specific tax form by ID.
 */
export const taxFormGetTaxFormOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await taxFormGetTaxForm({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: taxFormGetTaxFormQueryKey(options),
    });
};
export const taxFormCancelMailingQueryKey = (options) => createQueryKey('taxFormCancelMailing', options);
/**
 * Cancel scheduled mailing
 * Cancel a scheduled mailing of a tax form.
 */
export const taxFormCancelMailingOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await taxFormCancelMailing({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: taxFormCancelMailingQueryKey(options),
    });
};
/**
 * Cancel scheduled mailing
 * Cancel a scheduled mailing of a tax form.
 */
export const taxFormCancelMailingMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await taxFormCancelMailing({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const taxFormScheduleMailingQueryKey = (options) => createQueryKey('taxFormScheduleMailing', options);
/**
 * Schedule mailing
 * Schedule physical mailing of a tax form to the taxpayer. If federal filing is required, the tax form must have been accepted by the IRS. If state filing is required, the tax form must have been accepted by the state.
 */
export const taxFormScheduleMailingOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await taxFormScheduleMailing({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: taxFormScheduleMailingQueryKey(options),
    });
};
/**
 * Schedule mailing
 * Schedule physical mailing of a tax form to the taxpayer. If federal filing is required, the tax form must have been accepted by the IRS. If state filing is required, the tax form must have been accepted by the state.
 */
export const taxFormScheduleMailingMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await taxFormScheduleMailing({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSearchTransfersQueryKey = (options) => createQueryKey('transferSearchTransfers', options);
/**
 * List all transfers
 * List all transfers across all transfer types under your platform.
 */
export const transferSearchTransfersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSearchTransfers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSearchTransfersQueryKey(options),
    });
};
export const transferAchListTransfersQueryKey = (options) => createQueryKey('transferAchListTransfers', options);
/**
 * List all ACH transfers
 * Retrieve all ACH transfers under your developer account. Filtered results can be retrieved with extra parameters in the query (`bank_account_id`, `counterparty_id`, etc.).
 */
export const transferAchListTransfersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchListTransfers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchListTransfersQueryKey(options),
    });
};
export const transferAchCreateTransferQueryKey = (options) => createQueryKey('transferAchCreateTransfer', options);
/**
 * Create an ACH transfer
 * Creates an ACH transfer between an account and a `counterparty`.
 */
export const transferAchCreateTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchCreateTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchCreateTransferQueryKey(options),
    });
};
/**
 * Create an ACH transfer
 * Creates an ACH transfer between an account and a `counterparty`.
 */
export const transferAchCreateTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchCreateTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchGetTransferQueryKey = (options) => createQueryKey('transferAchGetTransfer', options);
/**
 * Get an ACH transfer
 * Retrieves a single transfer by its ID.
 */
export const transferAchGetTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchGetTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchGetTransferQueryKey(options),
    });
};
export const transferAchCancelTransferQueryKey = (options) => createQueryKey('transferAchCancelTransfer', options);
/**
 * Cancel an ACH transfer
 * Cancels an ACH transfer before it is sent to the Federal Reserve. This action can be performed only if a given transfer is `INITIATED` or `HOLD`. Canceling a held transfer returns the held funds to the available balance. You can read more about [ACH states here]({{ach.states}}).
 */
export const transferAchCancelTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchCancelTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchCancelTransferQueryKey(options),
    });
};
/**
 * Cancel an ACH transfer
 * Cancels an ACH transfer before it is sent to the Federal Reserve. This action can be performed only if a given transfer is `INITIATED` or `HOLD`. Canceling a held transfer returns the held funds to the available balance. You can read more about [ACH states here]({{ach.states}}).
 */
export const transferAchCancelTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchCancelTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchClearTransferQueryKey = (options) => createQueryKey('transferAchClearTransfer', options);
/**
 * Clear a held ACH transfer
 * Release the hold on an ACH transfer in a `hold` state. The transfer is initiated as if it had just been created: the effective date and same-day eligibility are resolved against the clear time, and limits, sanctions screening and fraud checks are all evaluated now rather than when the hold was created. A held credit's funds are debited directly from the holding balance; a held debit never segregated funds, so clearing it simply resumes initiation.
 */
export const transferAchClearTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchClearTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchClearTransferQueryKey(options),
    });
};
/**
 * Clear a held ACH transfer
 * Release the hold on an ACH transfer in a `hold` state. The transfer is initiated as if it had just been created: the effective date and same-day eligibility are resolved against the clear time, and limits, sanctions screening and fraud checks are all evaluated now rather than when the hold was created. A held credit's funds are debited directly from the holding balance; a held debit never segregated funds, so clearing it simply resumes initiation.
 */
export const transferAchClearTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchClearTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchGetReturnQueryKey = (options) => createQueryKey('transferAchGetReturn', options);
/**
 * Get an ACH return
 * Retrieve the return processing details of an ACH transfer. The return may be either filed by your platform, or sent to you by other RDFIs.
 */
export const transferAchGetReturnOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchGetReturn({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchGetReturnQueryKey(options),
    });
};
export const transferAchCreateReturnQueryKey = (options) => createQueryKey('transferAchCreateReturn', options);
/**
 * Create an ACH return
 * Submit a request to return an incoming ACH transfer that is sent by other ODFIs (i.e. Column is the RDFI). At most one return request can be submitted for each incoming ACH transfer. You can read more about [ACH returns here]({{ach.returns.create}}).
 */
export const transferAchCreateReturnOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchCreateReturn({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchCreateReturnQueryKey(options),
    });
};
/**
 * Create an ACH return
 * Submit a request to return an incoming ACH transfer that is sent by other ODFIs (i.e. Column is the RDFI). At most one return request can be submitted for each incoming ACH transfer. You can read more about [ACH returns here]({{ach.returns.create}}).
 */
export const transferAchCreateReturnMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchCreateReturn({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchReverseTransferQueryKey = (options) => createQueryKey('transferAchReverseTransfer', options);
/**
 * Reverse an ACH transfer
 * Reverse an erroneous outgoing ACH transfer. You can read more about [ACH Reversals]({{ach.reversals}}).
 */
export const transferAchReverseTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchReverseTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchReverseTransferQueryKey(options),
    });
};
/**
 * Reverse an ACH transfer
 * Reverse an erroneous outgoing ACH transfer. You can read more about [ACH Reversals]({{ach.reversals}}).
 */
export const transferAchReverseTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchReverseTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchBatchListBatchesQueryKey = (options) => createQueryKey('transferAchBatchListBatches', options);
/**
 * List ACH transfer batches
 * List ACH transfer batches with optional filtering and pagination.
 */
export const transferAchBatchListBatchesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchBatchListBatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchBatchListBatchesQueryKey(options),
    });
};
export const transferAchBatchCreateBatchQueryKey = (options) => createQueryKey('transferAchBatchCreateBatch', options);
/**
 * Create an ACH transfer batch
 * Create a new ACH transfer batch for bulk import of transfers via NACHA or CSV.
 */
export const transferAchBatchCreateBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchBatchCreateBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchBatchCreateBatchQueryKey(options),
    });
};
/**
 * Create an ACH transfer batch
 * Create a new ACH transfer batch for bulk import of transfers via NACHA or CSV.
 */
export const transferAchBatchCreateBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchBatchCreateBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchBatchGetBatchQueryKey = (options) => createQueryKey('transferAchBatchGetBatch', options);
/**
 * Get an ACH transfer batch
 * Retrieve a single ACH transfer batch by its ID.
 */
export const transferAchBatchGetBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchBatchGetBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchBatchGetBatchQueryKey(options),
    });
};
export const transferAchBatchCancelBatchQueryKey = (options) => createQueryKey('transferAchBatchCancelBatch', options);
/**
 * Cancel an ACH transfer batch
 * Cancel an ACH transfer batch that has not yet been confirmed.
 */
export const transferAchBatchCancelBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchBatchCancelBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchBatchCancelBatchQueryKey(options),
    });
};
/**
 * Cancel an ACH transfer batch
 * Cancel an ACH transfer batch that has not yet been confirmed.
 */
export const transferAchBatchCancelBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchBatchCancelBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchBatchConfirmBatchQueryKey = (options) => createQueryKey('transferAchBatchConfirmBatch', options);
/**
 * Confirm an ACH transfer batch
 * Confirm a validated ACH transfer batch and begin creating individual ACH transfers from its records.
 */
export const transferAchBatchConfirmBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchBatchConfirmBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchBatchConfirmBatchQueryKey(options),
    });
};
/**
 * Confirm an ACH transfer batch
 * Confirm a validated ACH transfer batch and begin creating individual ACH transfers from its records.
 */
export const transferAchBatchConfirmBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchBatchConfirmBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchBatchUploadFileQueryKey = (options) => createQueryKey('transferAchBatchUploadFile', options);
/**
 * Upload a file to an ACH transfer batch
 * Upload a NACHA or CSV file to a pending ACH transfer batch.
 */
export const transferAchBatchUploadFileOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchBatchUploadFile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchBatchUploadFileQueryKey(options),
    });
};
/**
 * Upload a file to an ACH transfer batch
 * Upload a NACHA or CSV file to a pending ACH transfer batch.
 */
export const transferAchBatchUploadFileMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferAchBatchUploadFile({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferAchBatchListBatchRecordsQueryKey = (options) => createQueryKey('transferAchBatchListBatchRecords', options);
/**
 * List records in an ACH transfer batch
 * List individual records within an ACH transfer batch with optional filtering and pagination.
 */
export const transferAchBatchListBatchRecordsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchBatchListBatchRecords({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchBatchListBatchRecordsQueryKey(options),
    });
};
export const transferAchBatchGetBatchRecordQueryKey = (options) => createQueryKey('transferAchBatchGetBatchRecord', options);
/**
 * Get an ACH transfer batch record
 * Retrieve a single record within an ACH transfer batch by its ID.
 */
export const transferAchBatchGetBatchRecordOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchBatchGetBatchRecord({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchBatchGetBatchRecordQueryKey(options),
    });
};
export const transferAchListReturnsQueryKey = (options) => createQueryKey('transferAchListReturns', options);
/**
 * List all ACH returns
 * Retrieve the return processing details of all ACH transfers under your developer account, including both returns filed by your platform and returns sent by other RDFIs.
 */
export const transferAchListReturnsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAchListReturns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAchListReturnsQueryKey(options),
    });
};
export const transferAdminGetAdminTransferQueryKey = (options) => createQueryKey('transferAdminGetAdminTransfer', options);
/**
 * Get an admin transfer
 * Retrieve details of an admin transfer by its ID.
 */
export const transferAdminGetAdminTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferAdminGetAdminTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferAdminGetAdminTransferQueryKey(options),
    });
};
export const transferBatchListTransferBatchesQueryKey = (options) => createQueryKey('transferBatchListTransferBatches', options);
/**
 * List transfer batches
 * List transfer batches with optional filtering and pagination.
 */
export const transferBatchListTransferBatchesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferBatchListTransferBatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferBatchListTransferBatchesQueryKey(options),
    });
};
export const transferBatchCreateTransferBatchQueryKey = (options) => createQueryKey('transferBatchCreateTransferBatch', options);
/**
 * Create a transfer batch
 * Create a new transfer batch that groups multiple transfers for review.
 */
export const transferBatchCreateTransferBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferBatchCreateTransferBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferBatchCreateTransferBatchQueryKey(options),
    });
};
/**
 * Create a transfer batch
 * Create a new transfer batch that groups multiple transfers for review.
 */
export const transferBatchCreateTransferBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferBatchCreateTransferBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a transfer batch
 * Delete a transfer batch by its ID.
 */
export const transferBatchDeleteTransferBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferBatchDeleteTransferBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferBatchGetTransferBatchQueryKey = (options) => createQueryKey('transferBatchGetTransferBatch', options);
/**
 * Get a transfer batch
 * Retrieve a single transfer batch by its ID.
 */
export const transferBatchGetTransferBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferBatchGetTransferBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferBatchGetTransferBatchQueryKey(options),
    });
};
/**
 * Update a transfer batch
 * Update a transfer batch's metadata or status.
 */
export const transferBatchUpdateTransferBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferBatchUpdateTransferBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferBookListBookTransfersQueryKey = (options) => createQueryKey('transferBookListBookTransfers', options);
/**
 * List all book transfers
 * Retrieve all book transfers under your developer account. Filtered results can be retrieved with extra parameters in the query (`sender_bank_account_id`, `receiver_bank_account_id`, etc.).
 */
export const transferBookListBookTransfersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferBookListBookTransfers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferBookListBookTransfersQueryKey(options),
    });
};
export const transferBookCreateBookTransferQueryKey = (options) => createQueryKey('transferBookCreateBookTransfer', options);
/**
 * Create a book transfer
 * A book transfer is a transaction between two Column accounts that you own. They can happen instantly and can be sent 24 hours a day, 7 days a week. Both accounts need to be under your platform, but don't need to be under the same entity. Alternatively, you can send a book transfer in two steps, using the "hold" parameter and "clear" method. Book transfers in a "hold" state can be updated and canceled. There is no reversal functionality for book transfers. Simply swap the `sender_account_number_id` and `receiver_account_number_id` and repeat the request.
 */
export const transferBookCreateBookTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferBookCreateBookTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferBookCreateBookTransferQueryKey(options),
    });
};
/**
 * Create a book transfer
 * A book transfer is a transaction between two Column accounts that you own. They can happen instantly and can be sent 24 hours a day, 7 days a week. Both accounts need to be under your platform, but don't need to be under the same entity. Alternatively, you can send a book transfer in two steps, using the "hold" parameter and "clear" method. Book transfers in a "hold" state can be updated and canceled. There is no reversal functionality for book transfers. Simply swap the `sender_account_number_id` and `receiver_account_number_id` and repeat the request.
 */
export const transferBookCreateBookTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferBookCreateBookTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferBookGetBookTransferQueryKey = (options) => createQueryKey('transferBookGetBookTransfer', options);
/**
 * Get a book transfer
 * Retrieve a single book transfer by its ID.
 */
export const transferBookGetBookTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferBookGetBookTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferBookGetBookTransferQueryKey(options),
    });
};
/**
 * Update a book transfer
 * Update a book transfer by its ID. Transfer must be in a "hold" state. Only the `amount` can be updated.
 */
export const transferBookUpdateBookTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferBookUpdateBookTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferBookCancelBookTransferQueryKey = (options) => createQueryKey('transferBookCancelBookTransfer', options);
/**
 * Cancel a book transfer
 * Cancel a book transfer hold by its ID. Transfer must be in a "hold" state.
 */
export const transferBookCancelBookTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferBookCancelBookTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferBookCancelBookTransferQueryKey(options),
    });
};
/**
 * Cancel a book transfer
 * Cancel a book transfer hold by its ID. Transfer must be in a "hold" state.
 */
export const transferBookCancelBookTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferBookCancelBookTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferBookClearBookTransferQueryKey = (options) => createQueryKey('transferBookClearBookTransfer', options);
/**
 * Clear a book transfer
 * Clear a book transfer by its ID. Transfer must be in a "hold" state. If the `amount` is specified, then that amount will be cleared, regardless of the amount of the hold. If no amount is specified, then the amount of the hold will be cleared.
 */
export const transferBookClearBookTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferBookClearBookTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferBookClearBookTransferQueryKey(options),
    });
};
/**
 * Clear a book transfer
 * Clear a book transfer by its ID. Transfer must be in a "hold" state. If the `amount` is specified, then that amount will be cleared, regardless of the amount of the hold. If no amount is specified, then the amount of the hold will be cleared.
 */
export const transferBookClearBookTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferBookClearBookTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckListCheckTransfersQueryKey = (options) => createQueryKey('transferCheckListCheckTransfers', options);
/**
 * List all check transfers
 * Retrieve all check transfers on your platform.
 */
export const transferCheckListCheckTransfersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckListCheckTransfers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckListCheckTransfersQueryKey(options),
    });
};
export const transferCheckGetCheckTransferQueryKey = (options) => createQueryKey('transferCheckGetCheckTransfer', options);
/**
 * Get a check transfer
 * Retrieve a single check transfer by its ID.
 */
export const transferCheckGetCheckTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckGetCheckTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckGetCheckTransferQueryKey(options),
    });
};
export const transferCheckClearHeldCheckQueryKey = (options) => createQueryKey('transferCheckClearHeldCheck', options);
/**
 * Clear a held check
 * Release the hold on a check in a `hold` state and issue it. The check is validated and screened again at clear time, then printed and mailed if Column delivers it. A hold moves no money, so on a prefunded account the funds lock at clear, like an ordinary issuance.
 */
export const transferCheckClearHeldCheckOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckClearHeldCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckClearHeldCheckQueryKey(options),
    });
};
/**
 * Clear a held check
 * Release the hold on a check in a `hold` state and issue it. The check is validated and screened again at clear time, then printed and mailed if Column delivers it. A hold moves no money, so on a prefunded account the funds lock at clear, like an ordinary issuance.
 */
export const transferCheckClearHeldCheckMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckClearHeldCheck({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckCancelHeldCheckQueryKey = (options) => createQueryKey('transferCheckCancelHeldCheck', options);
/**
 * Cancel a held check
 * Abandon a check in a `hold` state. A held check holds no funds, so nothing is released — the check is simply never printed or mailed. An issued check requires a stop payment instead.
 */
export const transferCheckCancelHeldCheckOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckCancelHeldCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckCancelHeldCheckQueryKey(options),
    });
};
/**
 * Cancel a held check
 * Abandon a check in a `hold` state. A held check holds no funds, so nothing is released — the check is simply never printed or mailed. An issued check requires a stop payment instead.
 */
export const transferCheckCancelHeldCheckMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckCancelHeldCheck({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckGetPreviewPdfQueryKey = (options) => createQueryKey('transferCheckGetPreviewPdf', options);
/**
 * Get a check preview PDF for an issued transfer
 * Get a preview PDF for a transfer. Only available for checks delivered by Column.
 */
export const transferCheckGetPreviewPdfOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckGetPreviewPdf({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckGetPreviewPdfQueryKey(options),
    });
};
export const transferCheckCreateCheckReturnQueryKey = (options) => createQueryKey('transferCheckCreateCheckReturn', options);
/**
 * Create a check return
 * Submit a request to return an incoming check transfer received from an ODFI. At most one return request can be submitted for each check. You can read more about check returns here.
 */
export const transferCheckCreateCheckReturnOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckCreateCheckReturn({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckCreateCheckReturnQueryKey(options),
    });
};
/**
 * Create a check return
 * Submit a request to return an incoming check transfer received from an ODFI. At most one return request can be submitted for each check. You can read more about check returns here.
 */
export const transferCheckCreateCheckReturnMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckCreateCheckReturn({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckGetCheckReturnsQueryKey = (options) => createQueryKey('transferCheckGetCheckReturns', options);
/**
 * Get check transfer returns
 * Retrieve all returns for a check transfer by the check transfer ID.
 */
export const transferCheckGetCheckReturnsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckGetCheckReturns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckGetCheckReturnsQueryKey(options),
    });
};
export const transferCheckReviewTransferQueryKey = (options) => createQueryKey('transferCheckReviewTransfer', options);
/**
 * Review a check transfer
 * Approve or reject a check transfer that is pending review.
 */
export const transferCheckReviewTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckReviewTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckReviewTransferQueryKey(options),
    });
};
/**
 * Review a check transfer
 * Approve or reject a check transfer that is pending review.
 */
export const transferCheckReviewTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckReviewTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckStopPaymentQueryKey = (options) => createQueryKey('transferCheckStopPayment', options);
/**
 * Stop a check transfer
 * Create a stop payment on a single check transfer by its ID. A check can only be stopped if it is of type debit and is in `issued` or `manual_review` status. A stopped check will move into a `pending_stop` status with a `pending_stop_at` timestamp until funds are released, at which point the status will be `stopped` and the `stopped_at` timestamp will be set.
 */
export const transferCheckStopPaymentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckStopPayment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckStopPaymentQueryKey(options),
    });
};
/**
 * Stop a check transfer
 * Create a stop payment on a single check transfer by its ID. A check can only be stopped if it is of type debit and is in `issued` or `manual_review` status. A stopped check will move into a `pending_stop` status with a `pending_stop_at` timestamp until funds are released, at which point the status will be `stopped` and the `stopped_at` timestamp will be set.
 */
export const transferCheckStopPaymentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckStopPayment({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckDepositCheckQueryKey = (options) => createQueryKey('transferCheckDepositCheck', options);
/**
 * Deposit a check
 * Deposit a check into a Column bank account.
 */
export const transferCheckDepositCheckOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckDepositCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckDepositCheckQueryKey(options),
    });
};
/**
 * Deposit a check
 * Deposit a check into a Column bank account.
 */
export const transferCheckDepositCheckMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckDepositCheck({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckDepositbatchListBatchesQueryKey = (options) => createQueryKey('transferCheckDepositbatchListBatches', options);
/**
 * List check deposit batches
 * List check deposit batches with optional status filtering and pagination.
 */
export const transferCheckDepositbatchListBatchesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckDepositbatchListBatches({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckDepositbatchListBatchesQueryKey(options),
    });
};
export const transferCheckDepositbatchCreateBatchQueryKey = (options) => createQueryKey('transferCheckDepositbatchCreateBatch', options);
/**
 * Create a check deposit batch
 * Create a batch and optionally assign existing unbatched check deposits.
 */
export const transferCheckDepositbatchCreateBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckDepositbatchCreateBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckDepositbatchCreateBatchQueryKey(options),
    });
};
/**
 * Create a check deposit batch
 * Create a batch and optionally assign existing unbatched check deposits.
 */
export const transferCheckDepositbatchCreateBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckDepositbatchCreateBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a check deposit batch
 * Delete an empty check deposit batch.
 */
export const transferCheckDepositbatchDeleteBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckDepositbatchDeleteBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckDepositbatchGetBatchQueryKey = (options) => createQueryKey('transferCheckDepositbatchGetBatch', options);
/**
 * Get a check deposit batch
 * Retrieve a check deposit batch by ID.
 */
export const transferCheckDepositbatchGetBatchOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckDepositbatchGetBatch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckDepositbatchGetBatchQueryKey(options),
    });
};
/**
 * Update a check deposit batch
 * Update a check deposit batch's description or close time.
 */
export const transferCheckDepositbatchUpdateBatchMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckDepositbatchUpdateBatch({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckProcessCheckBackImageQueryKey = (options) => createQueryKey('transferCheckProcessCheckBackImage', options);
/**
 * Capture back of check
 * Preprocess an image of the back of a check. The response includes a processed TIFF image that conforms to the ICL file standard. The response fields are in the same format as the input of the check deposit API. We recommend placing the check on a darker background, such as a darker shade if the check paper is white. The check itself should occupy the majority of the image. Additionally, we suggest using a higher DPI to ensure that the characters are easily recognizable. It is also advisable to correctly orient the check. Note that the MICR and amount parsing is still in Beta. We recommend you validate parsed data with the user before submitting a check deposit.
 */
export const transferCheckProcessCheckBackImageOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckProcessCheckBackImage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckProcessCheckBackImageQueryKey(options),
    });
};
/**
 * Capture back of check
 * Preprocess an image of the back of a check. The response includes a processed TIFF image that conforms to the ICL file standard. The response fields are in the same format as the input of the check deposit API. We recommend placing the check on a darker background, such as a darker shade if the check paper is white. The check itself should occupy the majority of the image. Additionally, we suggest using a higher DPI to ensure that the characters are easily recognizable. It is also advisable to correctly orient the check. Note that the MICR and amount parsing is still in Beta. We recommend you validate parsed data with the user before submitting a check deposit.
 */
export const transferCheckProcessCheckBackImageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckProcessCheckBackImage({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckProcessCheckFrontImageQueryKey = (options) => createQueryKey('transferCheckProcessCheckFrontImage', options);
/**
 * Capture front of check
 * Preprocess an image of the front of a check. The response includes the parsed MICR Line data, deposit amount, and a processed TIFF image that conforms to the ICL file standard. The response fields are in the same format as the input of the check deposit API. We recommend placing the check on a darker background, such as a darker shade if the check paper is white. The check itself should occupy the majority of the image. Additionally, we suggest using a higher DPI to ensure that the characters are easily recognizable. It is also advisable to correctly orient the check. Note that the MICR and amount parsing is still in Beta. We recommend you validate parsed data with the user before submitting a check deposit.
 */
export const transferCheckProcessCheckFrontImageOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckProcessCheckFrontImage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckProcessCheckFrontImageQueryKey(options),
    });
};
/**
 * Capture front of check
 * Preprocess an image of the front of a check. The response includes the parsed MICR Line data, deposit amount, and a processed TIFF image that conforms to the ICL file standard. The response fields are in the same format as the input of the check deposit API. We recommend placing the check on a darker background, such as a darker shade if the check paper is white. The check itself should occupy the majority of the image. Additionally, we suggest using a higher DPI to ensure that the characters are easily recognizable. It is also advisable to correctly orient the check. Note that the MICR and amount parsing is still in Beta. We recommend you validate parsed data with the user before submitting a check deposit.
 */
export const transferCheckProcessCheckFrontImageMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckProcessCheckFrontImage({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckIssueCheckQueryKey = (options) => createQueryKey('transferCheckIssueCheck', options);
/**
 * Issue a check
 * Issue a check to a specific payee for a given amount. If mail_check_request is included, the check will be delivered by Column too.
 */
export const transferCheckIssueCheckOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckIssueCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckIssueCheckQueryKey(options),
    });
};
/**
 * Issue a check
 * Issue a check to a specific payee for a given amount. If mail_check_request is included, the check will be delivered by Column too.
 */
export const transferCheckIssueCheckMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckIssueCheck({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckLockboxListLockboxesQueryKey = (options) => createQueryKey('transferCheckLockboxListLockboxes', options);
/**
 * List all check lockboxes
 * Retrieve all check lockboxes under your platform.
 */
export const transferCheckLockboxListLockboxesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckLockboxListLockboxes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckLockboxListLockboxesQueryKey(options),
    });
};
export const transferCheckLockboxCreateLockboxQueryKey = (options) => createQueryKey('transferCheckLockboxCreateLockbox', options);
/**
 * Create a check lockbox
 * Create and assign a check lockbox to a bank account or account number. If you specify a bank account, Column assigns the lockbox to the account's default account number. Each account number can have at most one linked lockbox.
 */
export const transferCheckLockboxCreateLockboxOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckLockboxCreateLockbox({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckLockboxCreateLockboxQueryKey(options),
    });
};
/**
 * Create a check lockbox
 * Create and assign a check lockbox to a bank account or account number. If you specify a bank account, Column assigns the lockbox to the account's default account number. Each account number can have at most one linked lockbox.
 */
export const transferCheckLockboxCreateLockboxMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckLockboxCreateLockbox({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a check lockbox
 * Close a check lockbox by its ID. Once closed, the lockbox can no longer be used to receive mailed checks.
 */
export const transferCheckLockboxDeleteLockboxMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCheckLockboxDeleteLockbox({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCheckLockboxGetLockboxQueryKey = (options) => createQueryKey('transferCheckLockboxGetLockbox', options);
/**
 * Get a check lockbox
 * Retrieve a single check lockbox by its ID.
 */
export const transferCheckLockboxGetLockboxOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckLockboxGetLockbox({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckLockboxGetLockboxQueryKey(options),
    });
};
export const transferCheckListCheckReturnsQueryKey = (options) => createQueryKey('transferCheckListCheckReturns', options);
/**
 * List all check returns
 * Retrieve the return processing details of all check returns under your platform, including returns created by you and other financial institutions.
 */
export const transferCheckListCheckReturnsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCheckListCheckReturns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCheckListCheckReturnsQueryKey(options),
    });
};
export const transferCryptoListTransfersQueryKey = (options) => createQueryKey('transferCryptoListTransfers', options);
/**
 * List all crypto transfers
 * Retrieve all crypto transfers under your developer account. Filtered results can be retrieved with extra parameters in the query.
 */
export const transferCryptoListTransfersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCryptoListTransfers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCryptoListTransfersQueryKey(options),
    });
};
export const transferCryptoCreateTransferQueryKey = (options) => createQueryKey('transferCryptoCreateTransfer', options);
/**
 * Create an outgoing crypto transfer
 * Create an outgoing crypto transfer to send stablecoins to a crypto counterparty. The transfer will be funded from the bank account associated with the specified crypto payment address.
 */
export const transferCryptoCreateTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCryptoCreateTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCryptoCreateTransferQueryKey(options),
    });
};
/**
 * Create an outgoing crypto transfer
 * Create an outgoing crypto transfer to send stablecoins to a crypto counterparty. The transfer will be funded from the bank account associated with the specified crypto payment address.
 */
export const transferCryptoCreateTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCryptoCreateTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCryptoGetTransferQueryKey = (options) => createQueryKey('transferCryptoGetTransfer', options);
/**
 * Get crypto transfer
 * Retrieve a single crypto transfer by its ID.
 */
export const transferCryptoGetTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCryptoGetTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCryptoGetTransferQueryKey(options),
    });
};
export const transferCryptoClearHeldTransferQueryKey = (options) => createQueryKey('transferCryptoClearHeldTransfer', options);
/**
 * Clear a held crypto transfer
 * Release the hold on an outgoing crypto transfer in a `hold` state. The payout is initiated as if freshly created, with the held funds debited directly from the holding balance.
 */
export const transferCryptoClearHeldTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCryptoClearHeldTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCryptoClearHeldTransferQueryKey(options),
    });
};
/**
 * Clear a held crypto transfer
 * Release the hold on an outgoing crypto transfer in a `hold` state. The payout is initiated as if freshly created, with the held funds debited directly from the holding balance.
 */
export const transferCryptoClearHeldTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCryptoClearHeldTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferCryptoCancelHeldTransferQueryKey = (options) => createQueryKey('transferCryptoCancelHeldTransfer', options);
/**
 * Cancel a held crypto transfer
 * Abort an outgoing crypto transfer in a `hold` state. The held funds return to the available balance and nothing is ever screened or sent on-chain.
 */
export const transferCryptoCancelHeldTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferCryptoCancelHeldTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferCryptoCancelHeldTransferQueryKey(options),
    });
};
/**
 * Cancel a held crypto transfer
 * Abort an outgoing crypto transfer in a `hold` state. The held funds return to the available balance and nothing is ever screened or sent on-chain.
 */
export const transferCryptoCancelHeldTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferCryptoCancelHeldTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferFxtradeListFxTradesQueryKey = (options) => createQueryKey('transferFxtradeListFxTrades', options);
/**
 * List all FX trades
 * Retrieve all FX trades under your platform.
 */
export const transferFxtradeListFxTradesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferFxtradeListFxTrades({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferFxtradeListFxTradesQueryKey(options),
    });
};
export const transferFxtradeCreateFxTradeQueryKey = (options) => createQueryKey('transferFxtradeCreateFxTrade', options);
/**
 * Create an FX trade
 * Create a foreign exchange trade between two bank accounts on your platform: the sender account sells its currency and the receiver account buys its currency at a quoted rate. Exactly one of `sell_amount` or `buy_amount` is set; the quote resolves the other side.
 */
export const transferFxtradeCreateFxTradeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferFxtradeCreateFxTrade({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferFxtradeCreateFxTradeQueryKey(options),
    });
};
/**
 * Create an FX trade
 * Create a foreign exchange trade between two bank accounts on your platform: the sender account sells its currency and the receiver account buys its currency at a quoted rate. Exactly one of `sell_amount` or `buy_amount` is set; the quote resolves the other side.
 */
export const transferFxtradeCreateFxTradeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferFxtradeCreateFxTrade({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferFxtradeGetFxTradeQueryKey = (options) => createQueryKey('transferFxtradeGetFxTrade', options);
/**
 * Get an FX trade
 * Retrieve a single FX trade by its ID.
 */
export const transferFxtradeGetFxTradeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferFxtradeGetFxTrade({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferFxtradeGetFxTradeQueryKey(options),
    });
};
export const transferFxtradeBookFxTradeQueryKey = (options) => createQueryKey('transferFxtradeBookFxTrade', options);
/**
 * Book an FX trade
 * Book an initiated FX trade, committing to its quoted rate. A trade can only be booked before its `expired_at`; booking an already-booked trade is a no-op.
 */
export const transferFxtradeBookFxTradeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferFxtradeBookFxTrade({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferFxtradeBookFxTradeQueryKey(options),
    });
};
/**
 * Book an FX trade
 * Book an initiated FX trade, committing to its quoted rate. A trade can only be booked before its `expired_at`; booking an already-booked trade is a no-op.
 */
export const transferFxtradeBookFxTradeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferFxtradeBookFxTrade({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferFxtradeCancelFxTradeQueryKey = (options) => createQueryKey('transferFxtradeCancelFxTrade', options);
/**
 * Cancel an FX trade
 * Cancel an initiated FX trade before it is booked. The sold funds return to the sender account and the trade's quote is canceled. Booked trades cannot be canceled.
 */
export const transferFxtradeCancelFxTradeOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferFxtradeCancelFxTrade({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferFxtradeCancelFxTradeQueryKey(options),
    });
};
/**
 * Cancel an FX trade
 * Cancel an initiated FX trade before it is booked. The sold funds return to the sender account and the trade's quote is canceled. Booked trades cannot be canceled.
 */
export const transferFxtradeCancelFxTradeMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferFxtradeCancelFxTrade({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferFxtradeGetFxTradeConfigQueryKey = (options) => createQueryKey('transferFxtradeGetFxTradeConfig', options);
/**
 * Get the FX trade config
 * Retrieve your platform's FX trade spread config: the default spread, per-currency overrides, the USD revenue account, and the overdraft reserve account of each enabled currency.
 */
export const transferFxtradeGetFxTradeConfigOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferFxtradeGetFxTradeConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferFxtradeGetFxTradeConfigQueryKey(options),
    });
};
export const transferFxtradeUpdateFxTradeConfigQueryKey = (options) => createQueryKey('transferFxtradeUpdateFxTradeConfig', options);
/**
 * Update the FX trade config
 * Update your platform's FX trade spread config. Omitted fields are unchanged; a `null` currency override removes it. Spreads are capped at 500 bps, and overrides are only allowed for enabled currencies.
 */
export const transferFxtradeUpdateFxTradeConfigOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferFxtradeUpdateFxTradeConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferFxtradeUpdateFxTradeConfigQueryKey(options),
    });
};
/**
 * Update the FX trade config
 * Update your platform's FX trade spread config. Omitted fields are unchanged; a `null` currency override removes it. Spreads are capped at 500 bps, and overrides are only allowed for enabled currencies.
 */
export const transferFxtradeUpdateFxTradeConfigMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferFxtradeUpdateFxTradeConfig({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftListTransfersQueryKey = (options) => createQueryKey('transferSwiftListTransfers', options);
/**
 * List all international wire transfers
 * Retrieve all international wire transfers under your platform.
 */
export const transferSwiftListTransfersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftListTransfers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftListTransfersQueryKey(options),
    });
};
export const transferSwiftCreateTransferQueryKey = (options) => createQueryKey('transferSwiftCreateTransfer', options);
/**
 * Create an international wire transfer
 * Create an international wire transfer between a Column account and a counterparty. Transfer status can be tracked via the Tracking API.
 */
export const transferSwiftCreateTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftCreateTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftCreateTransferQueryKey(options),
    });
};
/**
 * Create an international wire transfer
 * Create an international wire transfer between a Column account and a counterparty. Transfer status can be tracked via the Tracking API.
 */
export const transferSwiftCreateTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftCreateTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftGetTransferQueryKey = (options) => createQueryKey('transferSwiftGetTransfer', options);
/**
 * Get international wire transfer
 * Retrieve a single international wire transfer by its ID.
 */
export const transferSwiftGetTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftGetTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftGetTransferQueryKey(options),
    });
};
export const transferSwiftCreateAmendmentQueryKey = (options) => createQueryKey('transferSwiftCreateAmendment', options);
/**
 * Create international wire amendment
 * Create an amendment for an international wire transfer that has been delivered. Amendments can only be created for outgoing transfers in specific statuses and only one amendment per transfer is allowed.
 * **Amendment Eligibility Requirements**: - Only **outgoing transfers** can be amended - Transfer must be in `initiated`, `submitted`, `delivered`, `settled`, or `completed` status - Only **one amendment per transfer** is allowed
 */
export const transferSwiftCreateAmendmentOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftCreateAmendment({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftCreateAmendmentQueryKey(options),
    });
};
/**
 * Create international wire amendment
 * Create an amendment for an international wire transfer that has been delivered. Amendments can only be created for outgoing transfers in specific statuses and only one amendment per transfer is allowed.
 * **Amendment Eligibility Requirements**: - Only **outgoing transfers** can be amended - Transfer must be in `initiated`, `submitted`, `delivered`, `settled`, or `completed` status - Only **one amendment per transfer** is allowed
 */
export const transferSwiftCreateAmendmentMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftCreateAmendment({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftCancelTransferQueryKey = (options) => createQueryKey('transferSwiftCancelTransfer', options);
/**
 * Cancel an outgoing international wire
 * Send a cancellation request to recall funds from the beneficiary for an outgoing international wire transfer. The beneficiary may approve or reject the cancellation request. Cancellation status can be tracked via the Tracking API.
 */
export const transferSwiftCancelTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftCancelTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftCancelTransferQueryKey(options),
    });
};
/**
 * Cancel an outgoing international wire
 * Send a cancellation request to recall funds from the beneficiary for an outgoing international wire transfer. The beneficiary may approve or reject the cancellation request. Cancellation status can be tracked via the Tracking API.
 */
export const transferSwiftCancelTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftCancelTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftClearHeldTransferQueryKey = (options) => createQueryKey('transferSwiftClearHeldTransfer', options);
/**
 * Clear a held international wire transfer
 * Release the hold on an international wire in a `hold` state. For an outgoing wire this sends it: the held funds are debited directly from the holding balance and never pass back through the available balance, and an FX transfer fails with `fx_quote_expired` if the hold outlived the quote booked at creation -- cancel the transfer instead. For an incoming wire this releases the held credit into the beneficiary's available balance and completes the transfer, firing the standard completed event.
 */
export const transferSwiftClearHeldTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftClearHeldTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftClearHeldTransferQueryKey(options),
    });
};
/**
 * Clear a held international wire transfer
 * Release the hold on an international wire in a `hold` state. For an outgoing wire this sends it: the held funds are debited directly from the holding balance and never pass back through the available balance, and an FX transfer fails with `fx_quote_expired` if the hold outlived the quote booked at creation -- cancel the transfer instead. For an incoming wire this releases the held credit into the beneficiary's available balance and completes the transfer, firing the standard completed event.
 */
export const transferSwiftClearHeldTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftClearHeldTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftCancelHeldTransferQueryKey = (options) => createQueryKey('transferSwiftCancelHeldTransfer', options);
/**
 * Cancel a held international wire transfer
 * Abort an international wire in a `hold` state. The held funds return to the available balance and the wire is never sent. Distinct from a cancellation request, which recalls a wire that has already been sent.
 */
export const transferSwiftCancelHeldTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftCancelHeldTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftCancelHeldTransferQueryKey(options),
    });
};
/**
 * Cancel a held international wire transfer
 * Abort an international wire in a `hold` state. The held funds return to the available balance and the wire is never sent. Distinct from a cancellation request, which recalls a wire that has already been sent.
 */
export const transferSwiftCancelHeldTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftCancelHeldTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftReturnTransferQueryKey = (options) => createQueryKey('transferSwiftReturnTransfer', options);
/**
 * Return an incoming international wire
 * Return an incoming international wire transfer to the originator. Return status can be tracked via the Tracking API.
 */
export const transferSwiftReturnTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftReturnTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftReturnTransferQueryKey(options),
    });
};
/**
 * Return an incoming international wire
 * Return an incoming international wire transfer to the originator. Return status can be tracked via the Tracking API.
 */
export const transferSwiftReturnTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftReturnTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftTrackTransferQueryKey = (options) => createQueryKey('transferSwiftTrackTransfer', options);
/**
 * Track an international wire transfer
 * Retrieve tracking information for an international wire transfer.
 */
export const transferSwiftTrackTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftTrackTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftTrackTransferQueryKey(options),
    });
};
export const transferSwiftCreateFinancialInstitutionTransferQueryKey = (options) => createQueryKey('transferSwiftCreateFinancialInstitutionTransfer', options);
/**
 * Create an FI credit transfer
 * Create an FI-to-FI (pacs.009-shaped) credit transfer, where the counterparty is the creditor financial institution rather than a beneficiary account holder. Available to correspondent banking platforms. USD only.
 */
export const transferSwiftCreateFinancialInstitutionTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftCreateFinancialInstitutionTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftCreateFinancialInstitutionTransferQueryKey(options),
    });
};
/**
 * Create an FI credit transfer
 * Create an FI-to-FI (pacs.009-shaped) credit transfer, where the counterparty is the creditor financial institution rather than a beneficiary account holder. Available to correspondent banking platforms. USD only.
 */
export const transferSwiftCreateFinancialInstitutionTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftCreateFinancialInstitutionTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftQueryFxQuoteQueryKey = (options) => createQueryKey('transferSwiftQueryFxQuote', options);
/**
 * Request a foreign exchange quote
 * Request a foreign exchange quote to exchange USD to other currencies for international wire transfers. Quotes are not booked until they are used in transfer requests.
 */
export const transferSwiftQueryFxQuoteOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftQueryFxQuote({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftQueryFxQuoteQueryKey(options),
    });
};
/**
 * Request a foreign exchange quote
 * Request a foreign exchange quote to exchange USD to other currencies for international wire transfers. Quotes are not booked until they are used in transfer requests.
 */
export const transferSwiftQueryFxQuoteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftQueryFxQuote({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftQueryFxRateSheetQueryKey = (options) => createQueryKey('transferSwiftQueryFxRateSheet', options);
/**
 * Get FX rate sheet
 * Retrieve the FX rate sheet for all foreign currencies that Column supports.
 */
export const transferSwiftQueryFxRateSheetOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftQueryFxRateSheet({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftQueryFxRateSheetQueryKey(options),
    });
};
export const transferSwiftGetFxQuoteQueryKey = (options) => createQueryKey('transferSwiftGetFxQuote', options);
/**
 * Get a foreign exchange quote
 * Retrieve a single foreign exchange quote by its ID.
 */
export const transferSwiftGetFxQuoteOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftGetFxQuote({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftGetFxQuoteQueryKey(options),
    });
};
export const transferSwiftBookFxQuoteQueryKey = (options) => createQueryKey('transferSwiftBookFxQuote', options);
/**
 * Book a foreign exchange quote
 * Book a single foreign exchange quote by its ID. If the quote has already been booked before, it will be returned.
 */
export const transferSwiftBookFxQuoteOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftBookFxQuote({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftBookFxQuoteQueryKey(options),
    });
};
/**
 * Book a foreign exchange quote
 * Book a single foreign exchange quote by its ID. If the quote has already been booked before, it will be returned.
 */
export const transferSwiftBookFxQuoteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftBookFxQuote({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferSwiftCancelFxQuoteQueryKey = (options) => createQueryKey('transferSwiftCancelFxQuote', options);
/**
 * Cancel a foreign exchange quote
 * Cancel a single foreign exchange quote by its ID. If the quote has already been used by an outgoing transfer, it cannot be canceled. If the quote has already been canceled before, it will be returned.
 */
export const transferSwiftCancelFxQuoteOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferSwiftCancelFxQuote({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferSwiftCancelFxQuoteQueryKey(options),
    });
};
/**
 * Cancel a foreign exchange quote
 * Cancel a single foreign exchange quote by its ID. If the quote has already been used by an outgoing transfer, it cannot be canceled. If the quote has already been canceled before, it will be returned.
 */
export const transferSwiftCancelFxQuoteMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferSwiftCancelFxQuote({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferLocalListTransfersQueryKey = (options) => createQueryKey('transferLocalListTransfers', options);
/**
 * List all local transfers
 * Retrieve all local transfers under your platform.
 */
export const transferLocalListTransfersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferLocalListTransfers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferLocalListTransfersQueryKey(options),
    });
};
export const transferLocalCreateTransferQueryKey = (options) => createQueryKey('transferLocalCreateTransfer', options);
/**
 * Create a local transfer
 * Create a local transfer between a Column account and a counterparty.
 */
export const transferLocalCreateTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferLocalCreateTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferLocalCreateTransferQueryKey(options),
    });
};
/**
 * Create a local transfer
 * Create a local transfer between a Column account and a counterparty.
 */
export const transferLocalCreateTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferLocalCreateTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferLocalGetTransferQueryKey = (options) => createQueryKey('transferLocalGetTransfer', options);
/**
 * Get a local transfer
 * Retrieve a single local transfer by its ID.
 */
export const transferLocalGetTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferLocalGetTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferLocalGetTransferQueryKey(options),
    });
};
export const transferLocalCancelTransferQueryKey = (options) => createQueryKey('transferLocalCancelTransfer', options);
/**
 * Cancel an outgoing local transfer
 * Cancel an outgoing local transfer before submission, or request a recall after it has been submitted.
 */
export const transferLocalCancelTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferLocalCancelTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferLocalCancelTransferQueryKey(options),
    });
};
/**
 * Cancel an outgoing local transfer
 * Cancel an outgoing local transfer before submission, or request a recall after it has been submitted.
 */
export const transferLocalCancelTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferLocalCancelTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeListTransfersQueryKey = (options) => createQueryKey('transferRealtimeListTransfers', options);
/**
 * List all realtime transfers
 * Retrieve all realtime transfers under your platform.
 */
export const transferRealtimeListTransfersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeListTransfers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeListTransfersQueryKey(options),
    });
};
export const transferRealtimeCreateTransferQueryKey = (options) => createQueryKey('transferRealtimeCreateTransfer', options);
/**
 * Create a realtime transfer
 * Create a realtime transfer between a Column account and a counterparty.
 */
export const transferRealtimeCreateTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeCreateTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeCreateTransferQueryKey(options),
    });
};
/**
 * Create a realtime transfer
 * Create a realtime transfer between a Column account and a counterparty.
 */
export const transferRealtimeCreateTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeCreateTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeGetTransferQueryKey = (options) => createQueryKey('transferRealtimeGetTransfer', options);
/**
 * Get a realtime transfer
 * Retrieve a single realtime transfer by its ID.
 */
export const transferRealtimeGetTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeGetTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeGetTransferQueryKey(options),
    });
};
export const transferRealtimeCancelTransferQueryKey = (options) => createQueryKey('transferRealtimeCancelTransfer', options);
/**
 * Cancel a held realtime transfer
 * Abort an outgoing realtime transfer in a `hold` state. The held funds return to the available balance and nothing is ever routed or sent. Completed outgoing transfers require a return request instead.
 */
export const transferRealtimeCancelTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeCancelTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeCancelTransferQueryKey(options),
    });
};
/**
 * Cancel a held realtime transfer
 * Abort an outgoing realtime transfer in a `hold` state. The held funds return to the available balance and nothing is ever routed or sent. Completed outgoing transfers require a return request instead.
 */
export const transferRealtimeCancelTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeCancelTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeClearTransferQueryKey = (options) => createQueryKey('transferRealtimeClearTransfer', options);
/**
 * Clear a held realtime transfer
 * Release the hold on a realtime transfer in a `hold` state. For an outgoing transfer the rail (FedNow or RTP) is selected at clear time and the transfer is sent, with the held funds debited directly from the holding balance. For an incoming transfer the received funds move from the holding balance into the available balance and the transfer completes; nothing is sent to the network.
 */
export const transferRealtimeClearTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeClearTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeClearTransferQueryKey(options),
    });
};
/**
 * Clear a held realtime transfer
 * Release the hold on a realtime transfer in a `hold` state. For an outgoing transfer the rail (FedNow or RTP) is selected at clear time and the transfer is sent, with the held funds debited directly from the holding balance. For an incoming transfer the received funds move from the holding balance into the available balance and the transfer completes; nothing is sent to the network.
 */
export const transferRealtimeClearTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeClearTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeReturnTransferQueryKey = (options) => createQueryKey('transferRealtimeReturnTransfer', options);
/**
 * Return a realtime transfer
 * Return a realtime transfer by its ID.
 */
export const transferRealtimeReturnTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeReturnTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeReturnTransferQueryKey(options),
    });
};
/**
 * Return a realtime transfer
 * Return a realtime transfer by its ID.
 */
export const transferRealtimeReturnTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeReturnTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeCreateReturnRequestQueryKey = (options) => createQueryKey('transferRealtimeCreateReturnRequest', options);
/**
 * Create a realtime return request
 * Create a return request for a realtime transfer by its ID.
 */
export const transferRealtimeCreateReturnRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeCreateReturnRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeCreateReturnRequestQueryKey(options),
    });
};
/**
 * Create a realtime return request
 * Create a return request for a realtime transfer by its ID.
 */
export const transferRealtimeCreateReturnRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeCreateReturnRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeListRfpQueryKey = (options) => createQueryKey('transferRealtimeListRfp', options);
/**
 * List all realtime RFPs
 * Retrieve all Realtime Requests for Payment (RFPs) under your platform.
 */
export const transferRealtimeListRfpOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeListRfp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeListRfpQueryKey(options),
    });
};
export const transferRealtimeCreateRfpQueryKey = (options) => createQueryKey('transferRealtimeCreateRfp', options);
/**
 * Create a realtime RFP
 * Create a Realtime Request For Payment (RFP) between a Column account and a counterparty.
 */
export const transferRealtimeCreateRfpOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeCreateRfp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeCreateRfpQueryKey(options),
    });
};
/**
 * Create a realtime RFP
 * Create a Realtime Request For Payment (RFP) between a Column account and a counterparty.
 */
export const transferRealtimeCreateRfpMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeCreateRfp({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeGetRfpQueryKey = (options) => createQueryKey('transferRealtimeGetRfp', options);
/**
 * Get a realtime RFP
 * Retrieve a single Realtime Request for Payment (RFP) by its ID.
 */
export const transferRealtimeGetRfpOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeGetRfp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeGetRfpQueryKey(options),
    });
};
/**
 * Accept a realtime RFP
 * Accept an outstanding Realtime RFP by its ID. Only incoming Realtime RFPs with status presented or received can be accepted.
 */
export const transferRealtimeAcceptRfpMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeAcceptRfp({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Reject a realtime RFP
 * Reject an outstanding Realtime RFP by its ID. Only incoming Realtime RFPs in status presented or received can be rejected.
 */
export const transferRealtimeRejectRfpMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeRejectRfp({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferRealtimeListReturnRequestsQueryKey = (options) => createQueryKey('transferRealtimeListReturnRequests', options);
/**
 * List all realtime return requests
 * Retrieve all Realtime returns under your developer account.
 */
export const transferRealtimeListReturnRequestsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeListReturnRequests({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeListReturnRequestsQueryKey(options),
    });
};
export const transferRealtimeGetReturnRequestQueryKey = (options) => createQueryKey('transferRealtimeGetReturnRequest', options);
/**
 * Get a realtime return request by ID
 * Retrieves a single Realtime return request by its ID.
 */
export const transferRealtimeGetReturnRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferRealtimeGetReturnRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferRealtimeGetReturnRequestQueryKey(options),
    });
};
/**
 * Accept a realtime return request
 * Accept an outstanding Realtime Return Request by its ID. Only incoming Realtime Return Requests with a pending status can be accepted.
 */
export const transferRealtimeAcceptReturnRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeAcceptReturnRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Reject a realtime return request
 * Reject an outstanding Realtime Return Request by its ID. Only incoming Realtime Return Requests with a pending status can be rejected.
 */
export const transferRealtimeRejectReturnRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferRealtimeRejectReturnRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireListWireTransfersQueryKey = (options) => createQueryKey('transferWireListWireTransfers', options);
/**
 * List all wire transfers
 * Retrieve all wire transfers under your platform.
 */
export const transferWireListWireTransfersOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireListWireTransfers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireListWireTransfersQueryKey(options),
    });
};
export const transferWireCreateWireTransferQueryKey = (options) => createQueryKey('transferWireCreateWireTransfer', options);
/**
 * Create a wire transfer
 * Create a wire transfer between a Column account and a counterparty.
 */
export const transferWireCreateWireTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireCreateWireTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireCreateWireTransferQueryKey(options),
    });
};
/**
 * Create a wire transfer
 * Create a wire transfer between a Column account and a counterparty.
 */
export const transferWireCreateWireTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireCreateWireTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireGetWireTransferQueryKey = (options) => createQueryKey('transferWireGetWireTransfer', options);
/**
 * Get wire transfer
 * Retrieve a single wire transfer by its ID.
 */
export const transferWireGetWireTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireGetWireTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireGetWireTransferQueryKey(options),
    });
};
export const transferWireCancelWireTransferQueryKey = (options) => createQueryKey('transferWireCancelWireTransfer', options);
/**
 * Cancel a held outgoing wire transfer
 * Abort an outgoing wire transfer in a `hold` state. The held funds return to the available balance and the wire is never sent.
 */
export const transferWireCancelWireTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireCancelWireTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireCancelWireTransferQueryKey(options),
    });
};
/**
 * Cancel a held outgoing wire transfer
 * Abort an outgoing wire transfer in a `hold` state. The held funds return to the available balance and the wire is never sent.
 */
export const transferWireCancelWireTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireCancelWireTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireClearWireTransferQueryKey = (options) => createQueryKey('transferWireClearWireTransfer', options);
/**
 * Clear a held wire transfer
 * Release the hold on a wire transfer in a `hold` state. For an incoming transfer the held funds move from the holding balance into the available balance and the transfer completes. For an outgoing transfer the held funds are released and the wire is sent.
 */
export const transferWireClearWireTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireClearWireTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireClearWireTransferQueryKey(options),
    });
};
/**
 * Clear a held wire transfer
 * Release the hold on a wire transfer in a `hold` state. For an incoming transfer the held funds move from the holding balance into the available balance and the transfer completes. For an outgoing transfer the held funds are released and the wire is sent.
 */
export const transferWireClearWireTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireClearWireTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireCreateWireReturnRequestQueryKey = (options) => createQueryKey('transferWireCreateWireReturnRequest', options);
/**
 * Create a wire return request
 * Sends an outgoing wire return request to request the return of funds of a previously sent outgoing wire transfer.
 */
export const transferWireCreateWireReturnRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireCreateWireReturnRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireCreateWireReturnRequestQueryKey(options),
    });
};
/**
 * Create a wire return request
 * Sends an outgoing wire return request to request the return of funds of a previously sent outgoing wire transfer.
 */
export const transferWireCreateWireReturnRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireCreateWireReturnRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireReverseWireTransferQueryKey = (options) => createQueryKey('transferWireReverseWireTransfer', options);
/**
 * Reverse an incoming wire transfer
 * Reverse an incoming wire transfer received in error. You can read more about [Wire Reversals]({{wire.reversals}}).
 */
export const transferWireReverseWireTransferOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireReverseWireTransfer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireReverseWireTransferQueryKey(options),
    });
};
/**
 * Reverse an incoming wire transfer
 * Reverse an incoming wire transfer received in error. You can read more about [Wire Reversals]({{wire.reversals}}).
 */
export const transferWireReverseWireTransferMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireReverseWireTransfer({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireListWireDrawdownRequestsQueryKey = (options) => createQueryKey('transferWireListWireDrawdownRequests', options);
/**
 * List all wire drawdown requests
 * Retrieve all wire drawdowns under your developer account.
 */
export const transferWireListWireDrawdownRequestsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireListWireDrawdownRequests({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireListWireDrawdownRequestsQueryKey(options),
    });
};
export const transferWireCreateWireDrawdownQueryKey = (options) => createQueryKey('transferWireCreateWireDrawdown', options);
/**
 * Create a wire drawdown request
 * Sends an outgoing wire drawdown to request funds from an external account.
 */
export const transferWireCreateWireDrawdownOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireCreateWireDrawdown({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireCreateWireDrawdownQueryKey(options),
    });
};
/**
 * Create a wire drawdown request
 * Sends an outgoing wire drawdown to request funds from an external account.
 */
export const transferWireCreateWireDrawdownMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireCreateWireDrawdown({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireGetWireDrawdownRequestQueryKey = (options) => createQueryKey('transferWireGetWireDrawdownRequest', options);
/**
 * Get a wire drawdown request
 * Retrieves a single wire drawdown request by its ID.
 */
export const transferWireGetWireDrawdownRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireGetWireDrawdownRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireGetWireDrawdownRequestQueryKey(options),
    });
};
export const transferWireApproveWireDrawdownRequestQueryKey = (options) => createQueryKey('transferWireApproveWireDrawdownRequest', options);
/**
 * Approve a wire drawdown request
 * Approves a single wire drawdown request by its ID. If approved, an outgoing wire is initiated using the information specified in the drawdown request.
 */
export const transferWireApproveWireDrawdownRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireApproveWireDrawdownRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireApproveWireDrawdownRequestQueryKey(options),
    });
};
/**
 * Approve a wire drawdown request
 * Approves a single wire drawdown request by its ID. If approved, an outgoing wire is initiated using the information specified in the drawdown request.
 */
export const transferWireApproveWireDrawdownRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireApproveWireDrawdownRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireListWireReturnRequestsQueryKey = (options) => createQueryKey('transferWireListWireReturnRequests', options);
/**
 * List all wire return requests
 * Retrieve all wire returns under your developer account.
 */
export const transferWireListWireReturnRequestsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireListWireReturnRequests({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireListWireReturnRequestsQueryKey(options),
    });
};
export const transferWireGetWireReturnRequestQueryKey = (options) => createQueryKey('transferWireGetWireReturnRequest', options);
/**
 * Get a wire return request
 * Retrieves a single wire return request by its ID.
 */
export const transferWireGetWireReturnRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireGetWireReturnRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireGetWireReturnRequestQueryKey(options),
    });
};
export const transferWireApproveWireReturnRequestQueryKey = (options) => createQueryKey('transferWireApproveWireReturnRequest', options);
/**
 * Approve a wire return request
 * Approves a single wire return request by its ID. If approved, an outgoing wire is initiated using the information specified in the return request.
 */
export const transferWireApproveWireReturnRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireApproveWireReturnRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireApproveWireReturnRequestQueryKey(options),
    });
};
/**
 * Approve a wire return request
 * Approves a single wire return request by its ID. If approved, an outgoing wire is initiated using the information specified in the return request.
 */
export const transferWireApproveWireReturnRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireApproveWireReturnRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const transferWireRejectWireReturnRequestQueryKey = (options) => createQueryKey('transferWireRejectWireReturnRequest', options);
/**
 * Reject a wire return request
 * Rejects a single wire return request by its ID. If rejected, a return response is sent to the requestor.
 */
export const transferWireRejectWireReturnRequestOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await transferWireRejectWireReturnRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: transferWireRejectWireReturnRequestQueryKey(options),
    });
};
/**
 * Reject a wire return request
 * Rejects a single wire return request by its ID. If rejected, a return response is sent to the requestor.
 */
export const transferWireRejectWireReturnRequestMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await transferWireRejectWireReturnRequest({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webhookListEndpointWebhookDeliveriesQueryKey = (options) => createQueryKey('webhookListEndpointWebhookDeliveries', options);
/**
 * List all webhook deliveries
 * List all the webhook delivery and retry attempts for this endpoint.
 */
export const webhookListEndpointWebhookDeliveriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookListEndpointWebhookDeliveries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookListEndpointWebhookDeliveriesQueryKey(options),
    });
};
export const webhookListEventWebhookDeliveriesQueryKey = (options) => createQueryKey('webhookListEventWebhookDeliveries', options);
/**
 * List webhook deliveries by event
 * List all the webhook delivery and retry attempts for this event.
 */
export const webhookListEventWebhookDeliveriesOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookListEventWebhookDeliveries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookListEventWebhookDeliveriesQueryKey(options),
    });
};
export const webhookListWebhookEndpointsQueryKey = (options) => createQueryKey('webhookListWebhookEndpoints', options);
/**
 * List all webhook endpoints
 * List all webhooks under your developer account.
 */
export const webhookListWebhookEndpointsOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookListWebhookEndpoints({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookListWebhookEndpointsQueryKey(options),
    });
};
export const webhookCreateWebhookEndpointQueryKey = (options) => createQueryKey('webhookCreateWebhookEndpoint', options);
/**
 * Create a webhook endpoint
 * Create a webhook URL and description. This can also be done on the [dashboard]({{dashboard}}).
 */
export const webhookCreateWebhookEndpointOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookCreateWebhookEndpoint({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookCreateWebhookEndpointQueryKey(options),
    });
};
/**
 * Create a webhook endpoint
 * Create a webhook URL and description. This can also be done on the [dashboard]({{dashboard}}).
 */
export const webhookCreateWebhookEndpointMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webhookCreateWebhookEndpoint({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a webhook endpoint
 * Delete a webhook endpoint by its ID.
 */
export const webhookDeleteWebhookEndpointMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webhookDeleteWebhookEndpoint({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webhookGetWebhookEndpointQueryKey = (options) => createQueryKey('webhookGetWebhookEndpoint', options);
/**
 * Get a webhook endpoint
 * Retrieve a single webhook endpoint by its ID.
 */
export const webhookGetWebhookEndpointOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookGetWebhookEndpoint({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookGetWebhookEndpointQueryKey(options),
    });
};
/**
 * Update a webhook endpoint
 * Update a webhook endpoint by its ID.
 */
export const webhookUpdateWebhookEndpointMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webhookUpdateWebhookEndpoint({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webhookVerifyWebhookEndpointQueryKey = (options) => createQueryKey('webhookVerifyWebhookEndpoint', options);
/**
 * Verify a webhook endpoint
 * Send a test event to a webhook endpoint to verify it is configured correctly.
 */
export const webhookVerifyWebhookEndpointOptions = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookVerifyWebhookEndpoint({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookVerifyWebhookEndpointQueryKey(options),
    });
};
/**
 * Verify a webhook endpoint
 * Send a test event to a webhook endpoint to verify it is configured correctly.
 */
export const webhookVerifyWebhookEndpointMutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webhookVerifyWebhookEndpoint({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webhookListEndpointWebhookDeliveries2QueryKey = (options) => createQueryKey('webhookListEndpointWebhookDeliveries2', options);
/**
 * List webhook deliveries by endpoint
 * @deprecated
 */
export const webhookListEndpointWebhookDeliveries2Options = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookListEndpointWebhookDeliveries2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookListEndpointWebhookDeliveries2QueryKey(options),
    });
};
export const webhookListEventWebhookDeliveries2QueryKey = (options) => createQueryKey('webhookListEventWebhookDeliveries2', options);
/**
 * List webhook deliveries by event
 * @deprecated
 */
export const webhookListEventWebhookDeliveries2Options = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookListEventWebhookDeliveries2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookListEventWebhookDeliveries2QueryKey(options),
    });
};
export const webhookListWebhookEndpoints2QueryKey = (options) => createQueryKey('webhookListWebhookEndpoints2', options);
/**
 * List all webhook endpoints
 * @deprecated
 */
export const webhookListWebhookEndpoints2Options = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookListWebhookEndpoints2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookListWebhookEndpoints2QueryKey(options),
    });
};
export const webhookCreateWebhookEndpoint2QueryKey = (options) => createQueryKey('webhookCreateWebhookEndpoint2', options);
/**
 * Create a webhook endpoint
 * @deprecated
 */
export const webhookCreateWebhookEndpoint2Options = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookCreateWebhookEndpoint2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookCreateWebhookEndpoint2QueryKey(options),
    });
};
/**
 * Create a webhook endpoint
 * @deprecated
 */
export const webhookCreateWebhookEndpoint2Mutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webhookCreateWebhookEndpoint2({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
/**
 * Delete a webhook endpoint
 * @deprecated
 */
export const webhookDeleteWebhookEndpoint2Mutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webhookDeleteWebhookEndpoint2({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webhookGetWebhookEndpoint2QueryKey = (options) => createQueryKey('webhookGetWebhookEndpoint2', options);
/**
 * Get a webhook endpoint
 * @deprecated
 */
export const webhookGetWebhookEndpoint2Options = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookGetWebhookEndpoint2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookGetWebhookEndpoint2QueryKey(options),
    });
};
/**
 * Update a webhook endpoint
 * @deprecated
 */
export const webhookUpdateWebhookEndpoint2Mutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webhookUpdateWebhookEndpoint2({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
export const webhookVerifyWebhookEndpoint2QueryKey = (options) => createQueryKey('webhookVerifyWebhookEndpoint2', options);
/**
 * Verify a webhook endpoint
 * @deprecated
 */
export const webhookVerifyWebhookEndpoint2Options = (options) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await webhookVerifyWebhookEndpoint2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: webhookVerifyWebhookEndpoint2QueryKey(options),
    });
};
/**
 * Verify a webhook endpoint
 * @deprecated
 */
export const webhookVerifyWebhookEndpoint2Mutation = (options) => {
    const mutationOptions = {
        mutationFn: async (localOptions) => {
            const { data } = await webhookVerifyWebhookEndpoint2({
                ...options,
                ...localOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
//# sourceMappingURL=react-query.gen.js.map